import { SupportedCountry } from '../../../shared/models/supportedCountry.model';

export enum SUPPORTED_LANGUAGE {
  BG = 'bg-BG', // Bulgarian
  HR = 'hr-HR', // Croatian
  CS = 'cs-CZ', // Czech
  DA = 'da-DK', // Danish
  NL = 'nl-NL', // Dutch
  EN = 'en-GB', // English
  ET = 'et-EE', // Estonian
  FI = 'fi-FI', // Finnish
  FR = 'fr-FR', // French
  DE = 'de-DE', // German
  HU = 'hu-HU', // Hungarian
  IT = 'it-IT', // Italian
  LV = 'lv-LV', // Latvian
  LT = 'lt-LT', // Lithuanian
  NB = 'nb-NO', // Norwegian
  PL = 'pl-PL', // Polish
  PT = 'pt-PT', // Portuguese
  RO = 'ro-RO', // Romanian
  RU = 'ru-RU', // Russian
  SR = 'sr-RS', // Serbian
  SK = 'sk-SK', // Slovak
  SL = 'sl-SI', // Slovenian
  ES = 'es-ES', // Spanish
  SV = 'sv-SE', // Swedish
  TR = 'tr-TR', // Turkish
  UK = 'uk-UA', // Ukrainian
  CA = 'en-CA', // Canada
  US = 'en-US', // United States
}

export const SUPPORTED_LOCALES = {
  bg: 'bg-BG', // Bulgarian
  cs: 'cs-CZ', // Czech
  da: 'da-DK', // Danish
  de: 'de-DE', // German
  at: 'de-AT', // Austria
  en: 'en-GB', // English
  es: 'es-ES', // Spanish
  et: 'et-EE', // Estonian
  fi: 'fi-FI', // Finnish
  fr: 'fr-FR', // French
  gb: 'en-GB', // English
  hr: 'hr-HR', // Croatian
  hu: 'hu-HU', // Hungarian
  it: 'it-IT', // Italian
  lv: 'lv-LV', // Latvian
  nl: 'nl-NL', // Dutch
  no: 'no-NO', // Norwegian
  nb: 'nb-NO', // Norwegian
  nn: 'nn-NO', // Norwegian
  pl: 'pl-PL', // Polish
  pt: 'pt-PT', // Portuguese
  ro: 'ro-RO', // Romanian
  ru: 'ru-RU', // Russian
  sk: 'sk-SK', // Slovak
  sv: 'sv-SE', // Swedish
  sl: 'sl-SI', // Slovenian
  tr: 'tr-TR', // Turkish
  lt: 'lt-LT', // Lithuanian
  uk: 'uk-UA', // Ukrainian
  sr: 'sr-RS', // Serbian
  lu: 'de-LU', // Luxemburg
};

export const COUNTRIES_ERROR_CODE_SEARCH = [
  'AT', // Austria
  'BE_fr', // Belgium
  'BE_nl', // Belgium
  'BG', // Bulgaria
  'CA', // Canada
  'CH', // Switzerland
  'CH_fr', // Switzerland
  'CN', // China
  'CZ', // Czech
  'DE', // German
  'DK', // Denmark
  'EE', // Estonia
  'ES', // Spain
  'FI', // Finland
  'FR', // France
  'GB', // Great Britain
  'HR', // Croatia
  'HU', // Hungary
  'IT', // Italy
  'LT', // Lithuania
  'LU', // Luxemburg
  'LV', // Latvia
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'RS', // Serbia
  'RU', // Russia
  'SE', // Sweden
  'SI', // Slovenia
  'SK', // Slovakia
  'TR', // Turkey
  'UA', // Ukraine
  'US', // United States
];
export const LANGUAGES_ = {
  [SUPPORTED_LOCALES.cs]: 'LANGUAGE.CZECH',
  [SUPPORTED_LOCALES.da]: 'LANGUAGE.DANISH',
  [SUPPORTED_LOCALES.de]: 'LANGUAGE.GERMAN',
  [SUPPORTED_LOCALES.en]: 'LANGUAGE.ENGLISH',
  [SUPPORTED_LOCALES.es]: 'LANGUAGE.SPANISH',
  [SUPPORTED_LOCALES.et]: 'LANGUAGE.ESTONIAN',
  [SUPPORTED_LOCALES.fi]: 'LANGUAGE.FINNISH',
  [SUPPORTED_LOCALES.fr]: 'LANGUAGE.FRENCH',
  [SUPPORTED_LOCALES.it]: 'LANGUAGE.ITALIAN',
  [SUPPORTED_LOCALES.lv]: 'LANGUAGE.LATVIAN',
  [SUPPORTED_LOCALES.nl]: 'LANGUAGE.DUTCH',
  [SUPPORTED_LOCALES.no]: 'LANGUAGE.NORWEGIAN',
  [SUPPORTED_LOCALES.nb]: 'LANGUAGE.NORWEGIAN',
  [SUPPORTED_LOCALES.nn]: 'LANGUAGE.NORWEGIAN',
  [SUPPORTED_LOCALES.pl]: 'LANGUAGE.POLISH',
  [SUPPORTED_LOCALES.pt]: 'LANGUAGE.PORTUGUESE',
  [SUPPORTED_LOCALES.ro]: 'LANGUAGE.ROMANIAN',
  [SUPPORTED_LOCALES.sk]: 'LANGUAGE.SLOVAK',
  [SUPPORTED_LOCALES.sl]: 'LANGUAGE.SLOVENIAN',
  [SUPPORTED_LOCALES.sv]: 'LANGUAGE.SWEDISH',
  [SUPPORTED_LOCALES.tr]: 'LANGUAGE.TURKISH',
  [SUPPORTED_LOCALES.hr]: 'LANGUAGE.CROATIAN',
  [SUPPORTED_LOCALES.bg]: 'LANGUAGE.BULGARIAN',
  [SUPPORTED_LOCALES.hu]: 'LANGUAGE.HUNGARIAN',
  [SUPPORTED_LOCALES.ru]: 'LANGUAGE.RUSSIAN',
  [SUPPORTED_LOCALES.lt]: 'LANGUAGE.LITHUANIAN',
  [SUPPORTED_LOCALES.uk]: 'LANGUAGE.UKRAINIAN',
  [SUPPORTED_LOCALES.sr]: 'LANGUAGE.SERBIAN',
};

export const SUPPORTED_LANGUAGE_DIAL_CODE = {
  [SUPPORTED_LOCALES.cs]: '+420',
  [SUPPORTED_LOCALES.da]: '+45',
  [SUPPORTED_LOCALES.de]: '+49',
  [SUPPORTED_LOCALES.at]: '+43',
  [SUPPORTED_LOCALES.en]: '+44',
  [SUPPORTED_LOCALES.es]: '+34',
  [SUPPORTED_LOCALES.et]: '+372',
  [SUPPORTED_LOCALES.fi]: '+358',
  [SUPPORTED_LOCALES.fr]: '+33',
  [SUPPORTED_LOCALES.it]: '+39',
  [SUPPORTED_LOCALES.lv]: '+371',
  [SUPPORTED_LOCALES.nl]: '+31',
  [SUPPORTED_LOCALES.no]: '+47',
  [SUPPORTED_LOCALES.pl]: '+48',
  [SUPPORTED_LOCALES.pt]: '+351',
  [SUPPORTED_LOCALES.ro]: '+40',
  [SUPPORTED_LOCALES.sk]: '+421',
  [SUPPORTED_LOCALES.sl]: '+386',
  [SUPPORTED_LOCALES.sv]: '+46',
  [SUPPORTED_LOCALES.tr]: '+90',
  [SUPPORTED_LOCALES.hr]: '+385',
  [SUPPORTED_LOCALES.bg]: '+359',
  [SUPPORTED_LOCALES.hu]: '+36',
  [SUPPORTED_LOCALES.ru]: '+7',
  [SUPPORTED_LOCALES.lt]: '+370',
  [SUPPORTED_LOCALES.uk]: '+380',
  [SUPPORTED_LOCALES.sr]: '+381',
  [SUPPORTED_LOCALES.lu]: '+352',
  // belgian phone number neeeded for the service app but no locale needed
  'nl-BE': '+32',
};

export enum SUPPORTED_COUNTRY_CODE {
  CS = 'cs-CZ',
  DA = 'da-DK',
  DE = 'de-DE',
  AT = 'de-AT',
  EN = 'en-GB',
  ES = 'es-ES',
  ET = 'et-EE',
  FI = 'fi-FI',
  FR = 'fr-FR',
  IT = 'it-IT',
  LV = 'lv-LV',
  NL = 'nl-NL',
  NO = 'no-NO',
  PL = 'pl-PL',
  PT = 'pt-PT',
  RO = 'ro-RO',
  SK = 'sk-SK',
  SL = 'sl-SI',
  SV = 'sv-SE',
  TR = 'tr-TR',
  HR = 'hr-HR',
  BG = 'bg-BG',
  HU = 'hu-HU',
  RU = 'ru-RU',
  LT = 'lt-LT',
  UK = 'uk-UA',
  SR = 'sr-RS',
  BE = 'nl-BE',
}

export const DATEFORMATS = {
  [SUPPORTED_LOCALES.cs]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.da]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.de]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.de]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.en]: 'MM/DD/YYYY',
  [SUPPORTED_LOCALES.es]: 'DD/MM/YYYY',
  [SUPPORTED_LOCALES.et]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.fi]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.fr]: 'DD/MM/YYYY',
  [SUPPORTED_LOCALES.it]: 'DD/MM/YYYY',
  [SUPPORTED_LOCALES.lv]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.nl]: 'DD-MM-YYYY',
  [SUPPORTED_LOCALES.nb]: 'DD-MM-YYYY',
  [SUPPORTED_LOCALES.nn]: 'DD-MM-YYYY',
  [SUPPORTED_LOCALES.no]: 'DD-MM-YYYY',
  [SUPPORTED_LOCALES.pl]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.pt]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.ro]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.sk]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.sl]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.sv]: 'YYYY-MM-DD',
  [SUPPORTED_LOCALES.tr]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.hr]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.bg]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.hu]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.ru]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.lt]: 'DD-MM-YYYY',
  [SUPPORTED_LOCALES.uk]: 'DD.MM.YYYY',
  [SUPPORTED_LOCALES.sr]: 'DD.MM.YYYY',
};

export const LANGUAGES = [
  {
    code: 'bg',
    name: 'LANGUAGE.BULGARIAN',
  },
  {
    code: 'zh',
    name: 'LANGUAGE.CHINESE',
  },
  {
    code: 'hr',
    name: 'LANGUAGE.CROATIAN',
  },
  {
    code: 'cs',
    name: 'LANGUAGE.CZECH',
  },
  {
    code: 'da',
    name: 'LANGUAGE.DANISH',
  },
  {
    code: 'nl',
    name: 'LANGUAGE.DUTCH',
  },
  {
    code: 'en',
    name: 'LANGUAGE.ENGLISH',
  },
  {
    code: 'et',
    name: 'LANGUAGE.ESTONIAN',
  },
  {
    code: 'fi',
    name: 'LANGUAGE.FINNISH',
  },
  {
    code: 'fr',
    name: 'LANGUAGE.FRENCH',
  },
  {
    code: 'de',
    name: 'LANGUAGE.GERMAN',
  },
  {
    code: 'hu',
    name: 'LANGUAGE.HUNGARIAN',
  },
  {
    code: 'it',
    name: 'LANGUAGE.ITALIAN',
  },
  {
    code: 'lv',
    name: 'LANGUAGE.LATVIAN',
  },
  {
    code: 'lt',
    name: 'LANGUAGE.LITHUANIAN',
  },
  {
    code: 'pl',
    name: 'LANGUAGE.POLISH',
  },
  {
    code: 'pt',
    name: 'LANGUAGE.PORTUGUESE',
  },
  {
    code: 'ro',
    name: 'LANGUAGE.ROMANIAN',
  },
  {
    code: 'ru',
    name: 'LANGUAGE.RUSSIAN',
  },
  {
    code: 'sv',
    name: 'LANGUAGE.SWEDISH',
  },
  {
    code: 'sk',
    name: 'LANGUAGE.SLOVAK',
  },
  {
    code: 'sl',
    name: 'LANGUAGE.SLOVENIAN',
  },
  {
    code: 'es',
    name: 'LANGUAGE.SPANISH',
  },
  {
    code: 'tr',
    name: 'LANGUAGE.TURKISH',
  },
  {
    code: 'lt',
    name: 'LANGUAGE.LITHUANIAN',
  },
  {
    code: 'sr',
    name: 'LANGUAGE.SERBIAN',
  },
  {
    code: 'uk',
    name: 'LANGUAGE.UKRAINIAN',
  },
];

export const SUPPORTED_COUNTRIES: SupportedCountry[] = [
  {
    countryCode: 'at',
    languageCode: 'de',
    locale: 'de-at',
    country: 'COUNTRY.AUSTRIA',
    language: 'LANGUAGE.GERMAN',
    regions: [
      {
        name: 'Burgenland',
        shortCode: '1',
      },
      {
        name: 'Kärnten',
        shortCode: '2',
      },
      {
        name: 'Niederösterreich',
        shortCode: '3',
      },
      {
        name: 'Oberösterreich',
        shortCode: '4',
      },
      {
        name: 'Salzburg',
        shortCode: '5',
      },
      {
        name: 'Steiermark',
        shortCode: '6',
      },
      {
        name: 'Tirol',
        shortCode: '7',
      },
      {
        name: 'Vorarlberg',
        shortCode: '8',
      },
      {
        name: 'Wien',
        shortCode: '9',
      },
    ],
  },
  {
    countryCode: 'cn',
    languageCode: 'zh',
    locale: 'zh-cn',
    country: 'COUNTRY.CHINA',
    language: 'LANGUAGE.CHINESE',
    regions: [
      {
        name: 'Anhui',
        shortCode: '34',
      },
      {
        name: 'Beijing',
        shortCode: '11',
      },
      {
        name: 'Chongqing',
        shortCode: '50',
      },
      {
        name: 'Fujian',
        shortCode: '35',
      },
      {
        name: 'Gansu',
        shortCode: '62',
      },
      {
        name: 'Guangdong',
        shortCode: '44',
      },
      {
        name: 'Guangxi',
        shortCode: '45',
      },
      {
        name: 'Guizhou',
        shortCode: '52',
      },
      {
        name: 'Hainan',
        shortCode: '46',
      },
      {
        name: 'Hebei',
        shortCode: '13',
      },
      {
        name: 'Heilongjiang',
        shortCode: '23',
      },
      {
        name: 'Henan',
        shortCode: '41',
      },
      {
        name: 'Hong Kong',
        shortCode: '91',
      },
      {
        name: 'Hubei',
        shortCode: '42',
      },
      {
        name: 'Hunan',
        shortCode: '43',
      },
      {
        name: 'Inner Mongolia',
        shortCode: '15',
      },
      {
        name: 'Jiangsu',
        shortCode: '32',
      },
      {
        name: 'Jiangxi',
        shortCode: '36',
      },
      {
        name: 'Jilin',
        shortCode: '22',
      },
      {
        name: 'Liaoning',
        shortCode: '21',
      },
      {
        name: 'Macau',
        shortCode: '92',
      },
      {
        name: 'Ningxia',
        shortCode: '64',
      },
      {
        name: 'Qinghai',
        shortCode: '63',
      },
      {
        name: 'Shaanxi',
        shortCode: '61',
      },
      {
        name: 'Shandong',
        shortCode: '37',
      },
      {
        name: 'Shanghai',
        shortCode: '31',
      },
      {
        name: 'Shanxi',
        shortCode: '14',
      },
      {
        name: 'Sichuan',
        shortCode: '51',
      },
      {
        name: 'Tianjin',
        shortCode: '12',
      },
      {
        name: 'Tibet',
        shortCode: '54',
      },
      {
        name: 'Xinjiang',
        shortCode: '65',
      },
      {
        name: 'Yunnan',
        shortCode: '53',
      },
      {
        name: 'Zhejiang',
        shortCode: '33',
      },
    ],
  },
  {
    countryCode: 'hr',
    languageCode: 'hr',
    locale: 'hr-hr',
    country: 'COUNTRY.CROATIA',
    language: 'LANGUAGE.CROATIAN',
    regions: [
      {
        name: 'Bjelovarsko-Bilogorska Županija',
        shortCode: '07',
      },
      {
        name: 'Brodsko-Posavska Županija',
        shortCode: '12',
      },
      {
        name: 'Dubrovačko-Neretvanska Županija',
        shortCode: '19',
      },
      {
        name: 'Grad Zagreb',
        shortCode: '21',
      },
      {
        name: 'Istarska Županija',
        shortCode: '18',
      },
      {
        name: 'Karlovačka Županija',
        shortCode: '04',
      },
      {
        name: 'Koprivničko-Krizevačka Županija',
        shortCode: '06',
      },
      {
        name: 'Krapinsko-Zagorska Županija',
        shortCode: '02',
      },
      {
        name: 'Ličko-Senjska Županija',
        shortCode: '09',
      },
      {
        name: 'Međimurska Županija',
        shortCode: '20',
      },
      {
        name: 'Osječko-Baranjska Županija',
        shortCode: '14',
      },
      {
        name: 'Požeško-Slavonska Županija',
        shortCode: '11',
      },
      {
        name: 'Primorsko-Goranska Županija',
        shortCode: '08',
      },
      {
        name: 'Sisačko-Moslavačka Županija',
        shortCode: '03',
      },
      {
        name: 'Splitsko-Dalmatinska Županija',
        shortCode: '17',
      },
      {
        name: 'Sibensko-Kninska Županija',
        shortCode: '15',
      },
      {
        name: 'Varaždinska Županija',
        shortCode: '05',
      },
      {
        name: 'Virovitičko-Podravska Županija',
        shortCode: '10',
      },
      {
        name: 'Vukovarsko-Srijemska Županija',
        shortCode: '16',
      },
      {
        name: 'Zadarska Županija',
        shortCode: '13',
      },
      {
        name: 'Zagrebacka Zupanija',
        shortCode: '01',
      },
    ],
  },
  {
    countryCode: 'cz',
    languageCode: 'cs',
    country: 'COUNTRY.CZECH',
    language: 'LANGUAGE.CZECH',
    regions: [
      {
        name: 'Hlavní město Praha',
        shortCode: 'PR',
      },
      {
        name: 'Jihočeský kraj',
        shortCode: 'JC',
      },
      {
        name: 'Jihomoravský kraj',
        shortCode: 'JM',
      },
      {
        name: 'Karlovarský kraj',
        shortCode: 'KA',
      },
      {
        name: 'Královéhradecký kraj',
        shortCode: 'KR',
      },
      {
        name: 'Liberecký kraj',
        shortCode: 'LI',
      },
      {
        name: 'Moravskoslezský kraj',
        shortCode: 'MO',
      },
      {
        name: 'Olomoucký kraj',
        shortCode: 'OL',
      },
      {
        name: 'Pardubický kraj',
        shortCode: 'PA',
      },
      {
        name: 'Plzeňský kraj',
        shortCode: 'PL',
      },
      {
        name: 'Středočeský kraj',
        shortCode: 'ST',
      },
      {
        name: 'Ústecký kraj',
        shortCode: 'US',
      },
      {
        name: 'Vysočina',
        shortCode: 'VY',
      },
      {
        name: 'Zlínský kraj',
        shortCode: 'ZL',
      },
    ],
  },
  {
    countryCode: 'be',
    languageCode: 'fr',
    locale: 'fr-be',
    country: 'COUNTRY.BELGIUM',
    language: 'LANGUAGE.FRENCH',
    regions: [
      {
        name: 'Bruxelles-Capitale',
        shortCode: 'BRU',
      },
      {
        name: 'Région Flamande',
        shortCode: 'VLG',
      },
      {
        name: 'Région Wallonië',
        shortCode: 'WAL',
      },
    ],
  },
  {
    countryCode: 'be_fr',
    languageCode: 'fr',
    locale: 'fr-be',
    country: 'COUNTRY.BELGIUM',
    language: 'LANGUAGE.FRENCH',
    regions: [],
  },
  {
    countryCode: 'be_nl',
    languageCode: 'nl',
    locale: 'nl-be',
    country: 'COUNTRY.BELGIUM',
    language: 'LANGUAGE.DUTCH',
    regions: [],
  },
  {
    countryCode: 'bg',
    languageCode: 'bg',
    locale: 'bg-bg',
    country: 'COUNTRY.BULGARIA',
    language: 'LANGUAGE.BULGARIAN',
    regions: [
      {
        name: 'Blagoevgrad',
        shortCode: '01',
      },
      {
        name: 'Burgas',
        shortCode: '02',
      },
      {
        name: 'Dobrich',
        shortCode: '08',
      },
      {
        name: 'Gabrovo',
        shortCode: '07',
      },
      {
        name: 'Jambol',
        shortCode: '28',
      },
      {
        name: 'Khaskovo',
        shortCode: '26',
      },
      {
        name: 'Kjustendil',
        shortCode: '10',
      },
      {
        name: 'Kurdzhali',
        shortCode: '09',
      },
      {
        name: 'Lovech',
        shortCode: '11',
      },
      {
        name: 'Montana',
        shortCode: '12',
      },
      {
        name: 'Pazardzhik',
        shortCode: '13',
      },
      {
        name: 'Pernik',
        shortCode: '14',
      },
      {
        name: 'Pleven',
        shortCode: '15',
      },
      {
        name: 'Plovdiv',
        shortCode: '16',
      },
      {
        name: 'Razgrad',
        shortCode: '17',
      },
      {
        name: 'Ruse',
        shortCode: '18',
      },
      {
        name: 'Shumen',
        shortCode: '27',
      },
      {
        name: 'Silistra',
        shortCode: '19',
      },
      {
        name: 'Sliven',
        shortCode: '20',
      },
      {
        name: 'Smoljan',
        shortCode: '21',
      },
      {
        name: 'Sofija',
        shortCode: '23',
      },
      {
        name: 'Sofija-Grad',
        shortCode: '22',
      },
      {
        name: 'Stara Zagora',
        shortCode: '24',
      },
      {
        name: 'Turgovishhe',
        shortCode: '25',
      },
      {
        name: 'Varna',
        shortCode: '03',
      },
      {
        name: 'Veliko Turnovo',
        shortCode: '04',
      },
      {
        name: 'Vidin',
        shortCode: '05',
      },
      {
        name: 'Vraca',
        shortCode: '06',
      },
    ],
  },
  {
    countryCode: 'dk',
    languageCode: 'da',
    locale: 'da-dk',
    country: 'COUNTRY.DENMARK',
    language: 'LANGUAGE.DANISH',
    regions: [
      {
        name: 'Hovedstaden',
        shortCode: '84',
      },
      {
        name: 'Kujalleq',
        shortCode: 'GL-KU',
      },
      {
        name: 'Midtjylland',
        shortCode: '82',
      },
      {
        name: 'Norderøerne',
        shortCode: 'FO-01',
      },
      {
        name: 'Nordjylland',
        shortCode: '81',
      },
      {
        name: 'Østerø',
        shortCode: 'FO-06',
      },
      {
        name: 'Qaasuitsup',
        shortCode: 'GL-QA',
      },
      {
        name: 'Qeqqata',
        shortCode: 'GL-QE',
      },
      {
        name: 'Sandø',
        shortCode: 'FO-02',
      },
      {
        name: 'Sermersooq',
        shortCode: 'GL-SM',
      },
      {
        name: 'Sjælland',
        shortCode: '85',
      },
      {
        name: 'Strømø',
        shortCode: 'FO-03',
      },
      {
        name: 'Suderø',
        shortCode: 'FO-04',
      },
      {
        name: 'Syddanmark',
        shortCode: '83',
      },
      {
        name: 'Vågø',
        shortCode: 'FO-05',
      },
    ],
  },
  {
    countryCode: 'ee',
    languageCode: 'et',
    locale: 'et-ee',
    country: 'COUNTRY.ESTONIA',
    language: 'LANGUAGE.ESTONIAN',
    regions: [
      {
        name: 'Harjumaa (Tallinn)',
        shortCode: '37',
      },
      {
        name: 'Hiiumaa (Kardla)',
        shortCode: '39',
      },
      {
        name: 'Ida-Virumaa (Johvi)',
        shortCode: '44',
      },
      {
        name: 'Järvamaa (Paide)',
        shortCode: '41',
      },
      {
        name: 'Jõgevamaa (Jogeva)',
        shortCode: '49',
      },
      {
        name: 'Läänemaa',
        shortCode: '57',
      },
      {
        name: 'Lääne-Virumaa (Rakvere)',
        shortCode: '59',
      },
      {
        name: 'Pärnumaa (Parnu)',
        shortCode: '67',
      },
      {
        name: 'Põlvamaa (Polva)',
        shortCode: '65',
      },
      {
        name: 'Raplamaa (Rapla)',
        shortCode: '70',
      },
      {
        name: 'Saaremaa (Kuessaare)',
        shortCode: '74',
      },
      {
        name: 'Tartumaa (Tartu)',
        shortCode: '78',
      },
      {
        name: 'Valgamaa (Valga)',
        shortCode: '82',
      },
      {
        name: 'Viljandimaa (Viljandi)',
        shortCode: '84',
      },
      {
        name: 'Võrumaa (Voru)',
        shortCode: '86',
      },
    ],
  },
  {
    countryCode: 'fi',
    languageCode: 'fi',
    locale: 'fi-fi',
    country: 'COUNTRY.FINLAND',
    language: 'LANGUAGE.FINNISH',
    regions: [
      {
        name: 'Ahvenanmaan lääni',
        shortCode: 'AL',
      },
      {
        name: 'Etelä-Suomen lääni',
        shortCode: 'ES',
      },
      {
        name: 'Itä-Suomen lääni',
        shortCode: 'IS',
      },
      {
        name: 'Länsi-Suomen lääni',
        shortCode: 'LS',
      },
      {
        name: 'Lapin lääni',
        shortCode: 'LL',
      },
      {
        name: 'Oulun lääni',
        shortCode: 'OL',
      },
    ],
  },
  {
    countryCode: 'fr',
    languageCode: 'fr',
    country: 'COUNTRY.FRANCE',
    language: 'LANGUAGE.FRENCH',
    regions: [
      {
        name: 'Auvergne-Rhône-Alpes',
        shortCode: 'ARA',
      },
      {
        name: 'Bourgogne-Franche-Comté',
        shortCode: 'BFC',
      },
      {
        name: 'Bretagne',
        shortCode: 'BRE',
      },
      {
        name: 'Centre-Val de Loire',
        shortCode: 'CVL',
      },
      {
        name: 'Corse',
        shortCode: 'COR',
      },
      {
        name: 'Grand Est',
        shortCode: 'GES',
      },
      {
        name: 'Hauts-de-France',
        shortCode: 'HDF',
      },
      {
        name: 'Île-de-France',
        shortCode: 'IDF',
      },
      {
        name: 'Normandie',
        shortCode: 'NOR',
      },
      {
        name: 'Nouvelle-Aquitaine',
        shortCode: 'NAQ',
      },
      {
        name: 'Occitanie',
        shortCode: 'OCC',
      },
      {
        name: 'Pays de la Loire',
        shortCode: 'PDL',
      },
      {
        name: `Provence-Alpes-Cote d'Azur`,
        shortCode: 'PAC',
      },
      {
        name: 'Clipperton',
        shortCode: 'CP',
      },
      {
        name: 'Guadeloupe',
        shortCode: 'GP',
      },
      {
        name: 'Guyane',
        shortCode: 'GF',
      },
      {
        name: 'Martinique',
        shortCode: 'MQ',
      },
      {
        name: 'Mayotte',
        shortCode: 'YT',
      },
      {
        name: 'Novelle-Calédonie',
        shortCode: 'NC',
      },
      {
        name: 'Polynésie',
        shortCode: 'PF',
      },
      {
        name: 'Saint-Pierre-et-Miquelon',
        shortCode: 'PM',
      },
      {
        name: 'Saint Barthélemy',
        shortCode: 'BL',
      },
      {
        name: 'Saint Martin',
        shortCode: 'MF',
      },
      {
        name: 'Réunion',
        shortCode: 'RE',
      },
      {
        name: 'Terres Australes Françaises',
        shortCode: 'TF',
      },
      {
        name: 'Wallis-et-Futuna',
        shortCode: 'WF',
      },
    ],
  },
  {
    countryCode: 'de',
    languageCode: 'de',
    locale: 'de-de',
    country: 'COUNTRY.GERMANY',
    language: 'LANGUAGE.GERMAN',
    regions: [
      {
        name: 'Baden-Württemberg',
        shortCode: 'BW',
      },
      {
        name: 'Bayern',
        shortCode: 'BY',
      },
      {
        name: 'Berlin',
        shortCode: 'BE',
      },
      {
        name: 'Brandenburg',
        shortCode: 'BB',
      },
      {
        name: 'Bremen',
        shortCode: 'HB',
      },
      {
        name: 'Hamburg',
        shortCode: 'HH',
      },
      {
        name: 'Hessen',
        shortCode: 'HE',
      },
      {
        name: 'Mecklenburg-Vorpommern',
        shortCode: 'MV',
      },
      {
        name: 'Niedersachsen',
        shortCode: 'NI',
      },
      {
        name: 'Nordrhein-Westfalen',
        shortCode: 'NW',
      },
      {
        name: 'Rheinland-Pfalz',
        shortCode: 'RP',
      },
      {
        name: 'Saarland',
        shortCode: 'SL',
      },
      {
        name: 'Sachsen',
        shortCode: 'SN',
      },
      {
        name: 'Sachsen-Anhalt',
        shortCode: 'ST',
      },
      {
        name: 'Schleswig-Holstein',
        shortCode: 'SH',
      },
      {
        name: 'Thüringen',
        shortCode: 'TH',
      },
    ],
  },
  {
    countryCode: 'gb',
    languageCode: 'en',
    locale: 'en-gb',
    country: 'COUNTRY.GREAT_BRITAIN',
    language: 'LANGUAGE.ENGLISH',
    regions: [
      {
        name: 'Avon',
        shortCode: 'AVN',
      },
      {
        name: 'Bedfordshire',
        shortCode: 'BDF',
      },
      {
        name: 'Berkshire',
        shortCode: 'BRK',
      },
      {
        name: 'Bristol, City of',
        shortCode: 'COB',
      },
      {
        name: 'Buckinghamshire',
        shortCode: 'BKM',
      },
      {
        name: 'Cambridgeshire',
        shortCode: 'CAM',
      },
      {
        name: 'Cheshire',
        shortCode: 'CHS',
      },
      {
        name: 'Cleveland',
        shortCode: 'CLV',
      },
      {
        name: 'Cornwall',
        shortCode: 'CON',
      },
      {
        name: 'Cumbria',
        shortCode: 'CMA',
      },
      {
        name: 'Derbyshire',
        shortCode: 'DBY',
      },
      {
        name: 'Devon',
        shortCode: 'DEV',
      },
      {
        name: 'Dorset',
        shortCode: 'DOR',
      },
      {
        name: 'Durham',
        shortCode: 'DUR',
      },
      {
        name: 'East Sussex',
        shortCode: 'SXE',
      },
      {
        name: 'Essex',
        shortCode: 'ESS',
      },
      {
        name: 'Gloucestershire',
        shortCode: 'GLS',
      },
      {
        name: 'Greater London',
        shortCode: 'LND',
      },
      {
        name: 'Greater Manchester',
        shortCode: 'GTM',
      },
      {
        name: 'Hampshire (County of Southampton)',
        shortCode: 'HAM',
      },
      {
        name: 'Hereford and Worcester',
        shortCode: 'HWR',
      },
      {
        name: 'Herefordshire',
        shortCode: 'HEF',
      },
      {
        name: 'Hertfordshire',
        shortCode: 'HRT',
      },
      {
        name: 'Isle of Wight',
        shortCode: 'IOW',
      },
      {
        name: 'Kent',
        shortCode: 'KEN',
      },
      {
        name: 'Lancashire',
        shortCode: 'LAN',
      },
      {
        name: 'Leicestershire',
        shortCode: 'LEI',
      },
      {
        name: 'Lincolnshire',
        shortCode: 'LIN',
      },
      {
        name: 'London',
        shortCode: 'LDN',
      },
      {
        name: 'Merseyside',
        shortCode: 'MSY',
      },
      {
        name: 'Middlesex',
        shortCode: 'MDX',
      },
      {
        name: 'Norfolk',
        shortCode: 'NFK',
      },
      {
        name: 'Northamptonshire',
        shortCode: 'NTH',
      },
      {
        name: 'Northumberland',
        shortCode: 'NBL',
      },
      {
        name: 'North Humberside',
        shortCode: 'NHM',
      },
      {
        name: 'North Yorkshire',
        shortCode: 'NYK',
      },
      {
        name: 'Nottinghamshire',
        shortCode: 'NTT',
      },
      {
        name: 'Oxfordshire',
        shortCode: 'OXF',
      },
      {
        name: 'Rutland',
        shortCode: 'RUT',
      },
      {
        name: 'Shropshire',
        shortCode: 'SAL',
      },
      {
        name: 'Somerset',
        shortCode: 'SOM',
      },
      {
        name: 'South Humberside',
        shortCode: 'SHM',
      },
      {
        name: 'South Yorkshire',
        shortCode: 'SYK',
      },
      {
        name: 'Staffordshire',
        shortCode: 'STS',
      },
      {
        name: 'Suffolk',
        shortCode: 'SFK',
      },
      {
        name: 'Surrey',
        shortCode: 'SRY',
      },
      {
        name: 'Tyne and Wear',
        shortCode: 'TWR',
      },
      {
        name: 'Warwickshire',
        shortCode: 'WAR',
      },
      {
        name: 'West Midlands',
        shortCode: 'WMD',
      },
      {
        name: 'West Sussex',
        shortCode: 'SXW',
      },
      {
        name: 'West Yorkshire',
        shortCode: 'WYK',
      },
      {
        name: 'Wiltshire',
        shortCode: 'WIL',
      },
      {
        name: 'Worcestershire',
        shortCode: 'WOR',
      },
      {
        name: 'Antrim',
        shortCode: 'ANT',
      },
      {
        name: 'Armagh',
        shortCode: 'ARM',
      },
      {
        name: 'Belfast, City of',
        shortCode: 'BLF',
      },
      {
        name: 'Down',
        shortCode: 'DOW',
      },
      {
        name: 'Fermanagh',
        shortCode: 'FER',
      },
      {
        name: 'Londonderry',
        shortCode: 'LDY',
      },
      {
        name: 'Derry, City of',
        shortCode: 'DRY',
      },
      {
        name: 'Tyrone',
        shortCode: 'TYR',
      },
      {
        name: 'Aberdeen, City of',
        shortCode: 'AN',
      },
      {
        name: 'Aberdeenshire',
        shortCode: 'ABD',
      },
      {
        name: 'Angus (Forfarshire)',
        shortCode: 'ANS',
      },
      {
        name: 'Argyll',
        shortCode: 'AGB',
      },
      {
        name: 'Ayrshire',
        shortCode: 'ARG',
      },
      {
        name: 'Banffshire',
        shortCode: 'BAN',
      },
      {
        name: 'Berwickshire',
        shortCode: 'BEW',
      },
      {
        name: 'Bute',
        shortCode: 'BUT',
      },
      {
        name: 'Caithness',
        shortCode: 'CAI',
      },
      {
        name: 'Clackmannanshire',
        shortCode: 'CLK',
      },
      {
        name: 'Cromartyshire',
        shortCode: 'COC',
      },
      {
        name: 'Dumfriesshire',
        shortCode: 'DFS',
      },
      {
        name: 'Dunbartonshire (Dumbarton)',
        shortCode: 'DNB',
      },
      {
        name: 'Dundee, City of',
        shortCode: 'DD',
      },
      {
        name: 'East Lothian (Haddingtonshire)',
        shortCode: 'ELN',
      },
      {
        name: 'Edinburgh, City of',
        shortCode: 'EB',
      },
      {
        name: 'Fife',
        shortCode: 'FIF',
      },
      {
        name: 'Glasgow, City of',
        shortCode: 'GLA',
      },
      {
        name: 'Inverness-shire',
        shortCode: 'INV',
      },
      {
        name: 'Kincardineshire',
        shortCode: 'KCD',
      },
      {
        name: 'Kinross-shire',
        shortCode: 'KRS',
      },
      {
        name: 'Kirkcudbrightshire',
        shortCode: 'KKD',
      },
      {
        name: 'Lanarkshire',
        shortCode: 'LKS',
      },
      {
        name: 'Midlothian (County of Edinburgh)',
        shortCode: 'MLN',
      },
      {
        name: 'Moray (Elginshire)',
        shortCode: 'MOR',
      },
      {
        name: 'Nairnshire',
        shortCode: 'NAI',
      },
      {
        name: 'Orkney',
        shortCode: 'OKI',
      },
      {
        name: 'Peeblesshire',
        shortCode: 'PEE',
      },
      {
        name: 'Perthshire',
        shortCode: 'PER',
      },
      {
        name: 'Renfrewshire',
        shortCode: 'RFW',
      },
      {
        name: 'Ross and Cromarty',
        shortCode: 'ROC',
      },
      {
        name: 'Ross-shire',
        shortCode: 'ROS',
      },
      {
        name: 'Roxburghshire',
        shortCode: 'ROX',
      },
      {
        name: 'Selkirkshire',
        shortCode: 'SEL',
      },
      {
        name: 'Shetland (Zetland)',
        shortCode: 'SHI',
      },
      {
        name: 'Stirlingshire',
        shortCode: 'STI',
      },
      {
        name: 'Sutherland',
        shortCode: 'SUT',
      },
      {
        name: 'West Lothian (Linlithgowshire)',
        shortCode: 'WLN',
      },
      {
        name: 'Wigtownshire',
        shortCode: 'WIG',
      },
      {
        name: 'Clwyd',
        shortCode: 'CWD',
      },
      {
        name: 'Dyfed',
        shortCode: 'DFD',
      },
      {
        name: 'Gwent',
        shortCode: 'GNT',
      },
      {
        name: 'Gwynedd',
        shortCode: 'GWN',
      },
      {
        name: 'Mid Glamorgan',
        shortCode: 'MGM',
      },
      {
        name: 'Powys',
        shortCode: 'POW',
      },
      {
        name: 'South Glamorgan',
        shortCode: 'SGM',
      },
      {
        name: 'West Glamorgan',
        shortCode: 'WGM',
      },
    ],
  },
  {
    countryCode: 'hu',
    languageCode: 'hu',
    locale: 'hu-hu',
    country: 'COUNTRY.HUNGARY',
    language: 'LANGUAGE.HUNGARIAN',
    regions: [
      {
        name: 'Bács-Kiskun',
        shortCode: 'BK',
      },
      {
        name: 'Baranya',
        shortCode: 'BA',
      },
      {
        name: 'Békés',
        shortCode: 'BE',
      },
      {
        name: 'Békéscsaba',
        shortCode: 'BC',
      },
      {
        name: 'Borsod-Abauj-Zemplen',
        shortCode: 'BZ',
      },
      {
        name: 'Budapest',
        shortCode: 'BU',
      },
      {
        name: 'Csongrád',
        shortCode: 'CS',
      },
      {
        name: 'Debrecen',
        shortCode: 'DE',
      },
      {
        name: 'Dunaújváros',
        shortCode: 'DU',
      },
      {
        name: 'Eger',
        shortCode: 'EG',
      },
      {
        name: 'Érd',
        shortCode: 'ER',
      },
      {
        name: 'Fejér',
        shortCode: 'FE',
      },
      {
        name: 'Győr',
        shortCode: 'GY',
      },
      {
        name: 'Győr-Moson-Sopron',
        shortCode: 'GS',
      },
      {
        name: 'Hajdú-Bihar',
        shortCode: 'HB',
      },
      {
        name: 'Heves',
        shortCode: 'HE',
      },
      {
        name: 'Hódmezővásárhely',
        shortCode: 'HV',
      },
      {
        name: 'Jász-Nagykun-Szolnok',
        shortCode: 'N',
      },
      {
        name: 'Kaposvár',
        shortCode: 'KV',
      },
      {
        name: 'Kecskemét',
        shortCode: 'KM',
      },
      {
        name: 'Komárom-Esztergom',
        shortCode: 'KE',
      },
      {
        name: 'Miskolc',
        shortCode: 'MI',
      },
      {
        name: 'Nagykanizsa',
        shortCode: 'NK',
      },
      {
        name: 'Nógrád',
        shortCode: 'NO',
      },
      {
        name: 'Nyíregyháza',
        shortCode: 'NY',
      },
      {
        name: 'Pécs',
        shortCode: 'PS',
      },
      {
        name: 'Pest',
        shortCode: 'PE',
      },
      {
        name: 'Salgótarján',
        shortCode: 'ST',
      },
      {
        name: 'Somogy',
        shortCode: 'SO',
      },
      {
        name: 'Sopron',
        shortCode: 'SN',
      },
      {
        name: 'Szabolcs-á-Bereg',
        shortCode: 'SZ',
      },
      {
        name: 'Szeged',
        shortCode: 'SD',
      },
      {
        name: 'Székesfehérvár',
        shortCode: 'SF',
      },
      {
        name: 'Szekszárd',
        shortCode: 'SS',
      },
      {
        name: 'Szolnok',
        shortCode: 'SK',
      },
      {
        name: 'Szombathely',
        shortCode: 'SH',
      },
      {
        name: 'Tatabánya',
        shortCode: 'TB',
      },
      {
        name: 'Tolna',
        shortCode: 'TO',
      },
      {
        name: 'Vas',
        shortCode: 'VA',
      },
      {
        name: 'Veszprém',
        shortCode: 'VE',
      },
      {
        name: 'Veszprém (City)',
        shortCode: 'VM',
      },
      {
        name: 'Zala',
        shortCode: 'ZA',
      },
      {
        name: 'Zalaegerszeg',
        shortCode: 'ZE',
      },
    ],
  },
  {
    countryCode: 'it',
    languageCode: 'it',
    locale: 'it-it',
    country: 'COUNTRY.ITALY',
    language: 'LANGUAGE.ITALIAN',
    regions: [
      {
        name: 'Abruzzo',
        shortCode: '65',
      },
      {
        name: 'Basilicata',
        shortCode: '77',
      },
      {
        name: 'Calabria',
        shortCode: '78',
      },
      {
        name: 'Campania',
        shortCode: '72',
      },
      {
        name: 'Emilia-Romagna',
        shortCode: '45',
      },
      {
        name: 'Friuli-Venezia Giulia',
        shortCode: '36',
      },
      {
        name: 'Lazio',
        shortCode: '62',
      },
      {
        name: 'Liguria',
        shortCode: '42',
      },
      {
        name: 'Lombardia',
        shortCode: '25',
      },
      {
        name: 'Marche',
        shortCode: '57',
      },
      {
        name: 'Molise',
        shortCode: '67',
      },
      {
        name: 'Piemonte',
        shortCode: '21',
      },
      {
        name: 'Puglia',
        shortCode: '75',
      },
      {
        name: 'Sardegna',
        shortCode: '88',
      },
      {
        name: 'Sicilia',
        shortCode: '82',
      },
      {
        name: 'Toscana',
        shortCode: '52',
      },
      {
        name: 'Trentino-Alto Adige',
        shortCode: '32',
      },
      {
        name: 'Umbria',
        shortCode: '55',
      },
      {
        name: `Valle d'Aosta`,
        shortCode: '23',
      },
      {
        name: 'Veneto',
        shortCode: '34',
      },
    ],
  },
  {
    countryCode: 'lv',
    languageCode: 'lv',
    locale: 'lv-lv',
    country: 'COUNTRY.LATVIA',
    language: 'LANGUAGE.LATVIAN',
    regions: [
      {
        name: 'Aglona',
        shortCode: '001',
      },
      {
        name: 'Aizkraukle',
        shortCode: '002',
      },
      {
        name: 'Aizpute',
        shortCode: '003',
      },
      {
        name: 'Aknīste',
        shortCode: '004',
      },
      {
        name: 'Aloja',
        shortCode: '005',
      },
      {
        name: 'Alsunga',
        shortCode: '06',
      },
      {
        name: 'Alūksne',
        shortCode: '007',
      },
      {
        name: 'Amata',
        shortCode: '008',
      },
      {
        name: 'Ape',
        shortCode: '009',
      },
      {
        name: 'Auce',
        shortCode: '010',
      },
      {
        name: 'Ādaži',
        shortCode: '011',
      },
      {
        name: 'Babīte',
        shortCode: '012',
      },
      {
        name: 'Baldone',
        shortCode: '013',
      },
      {
        name: 'Baltinava',
        shortCode: '014',
      },
      {
        name: 'Balvi',
        shortCode: '015',
      },
      {
        name: 'Bauska',
        shortCode: '016',
      },
      {
        name: 'Beverīna',
        shortCode: '017',
      },
      {
        name: 'Brocēni',
        shortCode: '018',
      },
      {
        name: 'Burtnieki',
        shortCode: '019',
      },
      {
        name: 'Carnikava',
        shortCode: '020',
      },
      {
        name: 'Cesvaine',
        shortCode: '021',
      },
      {
        name: 'Cēsis',
        shortCode: '022',
      },
      {
        name: 'Cibla',
        shortCode: '023',
      },
      {
        name: 'Dagda',
        shortCode: '024',
      },
      {
        name: 'Daugavpils',
        shortCode: '025',
      },
      {
        name: 'Daugavpils (City)',
        shortCode: 'DGV',
      },
      {
        name: 'Dobele',
        shortCode: '026',
      },
      {
        name: 'Dundaga',
        shortCode: '027',
      },
      {
        name: 'Durbe',
        shortCode: '028',
      },
      {
        name: 'Engure',
        shortCode: '029',
      },
      {
        name: 'Ērgļi',
        shortCode: '030',
      },
      {
        name: 'Garkalne',
        shortCode: '031',
      },
      {
        name: 'Grobiņa',
        shortCode: '032',
      },
      {
        name: 'Gulbene',
        shortCode: '033',
      },
      {
        name: 'Iecava',
        shortCode: '034',
      },
      {
        name: 'Ikšķile',
        shortCode: '035',
      },
      {
        name: 'Ilūkste',
        shortCode: '036',
      },
      {
        name: 'Inčukalns',
        shortCode: '037',
      },
      {
        name: 'Jaunjelgava',
        shortCode: '038',
      },
      {
        name: 'Jaunpiebalga',
        shortCode: '039',
      },
      {
        name: 'Jaunpils',
        shortCode: '040',
      },
      {
        name: 'Jelgava',
        shortCode: '041',
      },
      {
        name: 'Jelgava (City)',
        shortCode: 'JEL',
      },
      {
        name: 'Jēkabpils',
        shortCode: '042',
      },
      {
        name: 'Jēkabpils (City)',
        shortCode: 'JKB',
      },
      {
        name: 'Jūrmala (City)',
        shortCode: 'JUR',
      },
      {
        name: 'Kandava',
        shortCode: '043',
      },
      {
        name: 'Kārsava',
        shortCode: '044',
      },
      {
        name: 'Kocēni',
        shortCode: '045',
      },
      {
        name: 'Koknese',
        shortCode: '046',
      },
      {
        name: 'Krāslava',
        shortCode: '047',
      },
      {
        name: 'Krimulda',
        shortCode: '048',
      },
      {
        name: 'Krustpils',
        shortCode: '049',
      },
      {
        name: 'Kuldīga',
        shortCode: '050',
      },
      {
        name: 'Ķegums',
        shortCode: '051',
      },
      {
        name: 'Ķekava',
        shortCode: '052',
      },
      {
        name: 'Lielvārde',
        shortCode: '053',
      },
      {
        name: 'Liepāja',
        shortCode: 'LPX',
      },
      {
        name: 'Limbaži',
        shortCode: '054',
      },
      {
        name: 'Līgatne',
        shortCode: '055',
      },
      {
        name: 'Līvāni',
        shortCode: '056',
      },
      {
        name: 'Lubāna',
        shortCode: '057',
      },
      {
        name: 'Ludza',
        shortCode: '058',
      },
      {
        name: 'Madona',
        shortCode: '059',
      },
      {
        name: 'Mazsalaca',
        shortCode: '060',
      },
      {
        name: 'Mālpils',
        shortCode: '061',
      },
      {
        name: 'Mārupe',
        shortCode: '062',
      },
      {
        name: 'Mērsrags',
        shortCode: '063',
      },
      {
        name: 'Naukšēni',
        shortCode: '064',
      },
      {
        name: 'Nereta',
        shortCode: '065',
      },
      {
        name: 'Nīca',
        shortCode: '066',
      },
      {
        name: 'Ogre',
        shortCode: '067',
      },
      {
        name: 'Olaine',
        shortCode: '068',
      },
      {
        name: 'Ozolnieki',
        shortCode: '069',
      },
      {
        name: 'Pārgauja',
        shortCode: '070',
      },
      {
        name: 'Pāvilosta',
        shortCode: '071',
      },
      {
        name: 'Pļaviņas',
        shortCode: '072',
      },
      {
        name: 'Preiļi',
        shortCode: '073',
      },
      {
        name: 'Priekule',
        shortCode: '074',
      },
      {
        name: 'Priekuļi',
        shortCode: '075',
      },
      {
        name: 'Rauna',
        shortCode: '076',
      },
      {
        name: 'Rēzekne',
        shortCode: '077',
      },
      {
        name: 'Rēzekne (City)',
        shortCode: 'REZ',
      },
      {
        name: 'Riebiņi',
        shortCode: '078',
      },
      {
        name: 'Rīga',
        shortCode: 'RIX',
      },
      {
        name: 'Roja',
        shortCode: '079',
      },
      {
        name: 'Ropaži',
        shortCode: '080',
      },
      {
        name: 'Rucava',
        shortCode: '081',
      },
      {
        name: 'Rugāji',
        shortCode: '082',
      },
      {
        name: 'Rundāle',
        shortCode: '083',
      },
      {
        name: 'Rūjiena',
        shortCode: '084',
      },
      {
        name: 'Sala',
        shortCode: '085',
      },
      {
        name: 'Salacgrīva',
        shortCode: '086',
      },
      {
        name: 'Salaspils',
        shortCode: '087',
      },
      {
        name: 'Saldus',
        shortCode: '088',
      },
      {
        name: 'Saulkrasti',
        shortCode: '089',
      },
      {
        name: 'Sēja',
        shortCode: '090',
      },
      {
        name: 'Sigulda',
        shortCode: '091',
      },
      {
        name: 'Skrīveri',
        shortCode: '092',
      },
      {
        name: 'Skrunda',
        shortCode: '093',
      },
      {
        name: 'Smiltene',
        shortCode: '094',
      },
      {
        name: 'Stopiņi',
        shortCode: '095',
      },
      {
        name: 'Strenči',
        shortCode: '096',
      },
      {
        name: 'Talsi',
        shortCode: '097',
      },
      {
        name: 'Tērvete',
        shortCode: '098',
      },
      {
        name: 'Tukums',
        shortCode: '099',
      },
      {
        name: 'Vaiņode',
        shortCode: '100',
      },
      {
        name: 'Valka',
        shortCode: '101',
      },
      {
        name: 'Valmiera',
        shortCode: 'VMR',
      },
      {
        name: 'Varakļāni',
        shortCode: '102',
      },
      {
        name: 'Vārkava',
        shortCode: '103',
      },
      {
        name: 'Vecpiebalga',
        shortCode: '104',
      },
      {
        name: 'Vecumnieki',
        shortCode: '105',
      },
      {
        name: 'Ventspils',
        shortCode: '106',
      },
      {
        name: 'Ventspils (City)',
        shortCode: 'VEN',
      },
      {
        name: 'Viesīte',
        shortCode: '107',
      },
      {
        name: 'Viļaka',
        shortCode: '108',
      },
      {
        name: 'Viļāni',
        shortCode: '109',
      },
      {
        name: 'Zilupe',
        shortCode: '110',
      },
    ],
  },
  {
    countryCode: 'lu',
    languageCode: 'de',
    locale: 'de-lu',
    country: 'COUNTRY.LUXEMBURG',
    language: 'LANGUAGE.GERMAN',
    regions: [
      {
        name: 'Capellen',
        shortCode: 'CA',
      },
      {
        name: 'Clevaux',
        shortCode: 'CL',
      },
      {
        name: 'Diekirch',
        shortCode: 'DI',
      },
      {
        name: 'Echternach',
        shortCode: 'EC',
      },
      {
        name: 'Esch-sur-Alzette',
        shortCode: 'ES',
      },
      {
        name: 'Grevenmacher',
        shortCode: 'GR',
      },
      {
        name: 'Luxembourg',
        shortCode: 'LU',
      },
      {
        name: 'Mersch',
        shortCode: 'ME',
      },
      {
        name: 'Redange',
        shortCode: 'RD',
      },
      {
        name: 'Remich',
        shortCode: 'RM',
      },
      {
        name: 'Vianden',
        shortCode: 'VD',
      },
      {
        name: 'Wiltz',
        shortCode: 'WI',
      },
    ],
  },
  {
    countryCode: 'nl',
    languageCode: 'nl',
    locale: 'nl-nl',
    country: 'COUNTRY.NETHERLANDS',
    language: 'LANGUAGE.DUTCH',
    regions: [
      {
        name: 'Drenthe',
        shortCode: 'DR',
      },
      {
        name: 'Flevoland',
        shortCode: 'FL',
      },
      {
        name: 'Friesland',
        shortCode: 'FR',
      },
      {
        name: 'Gelderland',
        shortCode: 'GE',
      },
      {
        name: 'Groningen',
        shortCode: 'GR',
      },
      {
        name: 'Limburg',
        shortCode: 'LI',
      },
      {
        name: 'Noord-Brabant',
        shortCode: 'NB',
      },
      {
        name: 'Noord-Holland',
        shortCode: 'NH',
      },
      {
        name: 'Overijssel',
        shortCode: 'OV',
      },
      {
        name: 'Utrecht',
        shortCode: 'UT',
      },
      {
        name: 'Zeeland',
        shortCode: 'ZE',
      },
      {
        name: 'Zuid-Holland',
        shortCode: 'ZH',
      },
    ],
  },
  {
    countryCode: 'pl',
    languageCode: 'pl',
    locale: 'pl-pl',
    country: 'COUNTRY.POLAND',
    language: 'LANGUAGE.POLISH',
    regions: [
      {
        name: 'Dolnośląskie',
        shortCode: 'DS',
      },
      {
        name: 'Kujawsko-pomorskie',
        shortCode: 'KP',
      },
      {
        name: 'Lubelskie',
        shortCode: 'LU',
      },
      {
        name: 'Lubuskie',
        shortCode: 'LB',
      },
      {
        name: 'Łódzkie',
        shortCode: 'LD',
      },
      {
        name: 'Malopolskie',
        shortCode: 'MA',
      },
      {
        name: 'Mazowieckie',
        shortCode: 'MZ',
      },
      {
        name: 'Opolskie',
        shortCode: 'OP',
      },
      {
        name: 'Podkarpackie',
        shortCode: 'PK',
      },
      {
        name: 'Podlaskie',
        shortCode: 'PD',
      },
      {
        name: 'Pomorskie',
        shortCode: 'PM',
      },
      {
        name: 'Śląskie',
        shortCode: 'SL',
      },
      {
        name: 'Świętokrzyskie',
        shortCode: 'SK',
      },
      {
        name: 'Warmińsko-mazurskie',
        shortCode: 'WN',
      },
      {
        name: 'Wielkopolskie',
        shortCode: 'WP',
      },
      {
        name: 'Zachodniopomorskie',
        shortCode: 'ZP',
      },
    ],
  },
  {
    countryCode: 'pt',
    languageCode: 'pt',
    locale: 'pt-pt',
    country: 'COUNTRY.PORTUGAL',
    language: 'LANGUAGE.PORTUGUESE',
    regions: [
      {
        name: 'Acores',
        shortCode: '20',
      },
      {
        name: 'Aveiro',
        shortCode: '01',
      },
      {
        name: 'Beja',
        shortCode: '02',
      },
      {
        name: 'Braga',
        shortCode: '03',
      },
      {
        name: 'Braganca',
        shortCode: '04',
      },
      {
        name: 'Castelo Branco',
        shortCode: '05',
      },
      {
        name: 'Coimbra',
        shortCode: '06',
      },
      {
        name: 'Evora',
        shortCode: '07',
      },
      {
        name: 'Faro',
        shortCode: '08',
      },
      {
        name: 'Guarda',
        shortCode: '09',
      },
      {
        name: 'Leiria',
        shortCode: '10',
      },
      {
        name: 'Lisboa',
        shortCode: '11',
      },
      {
        name: 'Madeira',
        shortCode: '30',
      },
      {
        name: 'Portalegre',
        shortCode: '12',
      },
      {
        name: 'Porto',
        shortCode: '13',
      },
      {
        name: 'Santarem',
        shortCode: '14',
      },
      {
        name: 'Setubal',
        shortCode: '15',
      },
      {
        name: 'Viana do Castelo',
        shortCode: '16',
      },
      {
        name: 'Vila Real',
        shortCode: '17',
      },
      {
        name: 'Viseu',
        shortCode: '18',
      },
    ],
  },
  {
    countryCode: 'ro',
    languageCode: 'ro',
    locale: 'ro-ro',
    country: 'COUNTRY.ROMANIA',
    language: 'LANGUAGE.ROMANIAN',
    regions: [
      {
        name: 'Alba',
        shortCode: 'AB',
      },
      {
        name: 'Arad',
        shortCode: 'AR',
      },
      {
        name: 'Arges',
        shortCode: 'AG',
      },
      {
        name: 'Bacau',
        shortCode: 'BC',
      },
      {
        name: 'Bihor',
        shortCode: 'BH',
      },
      {
        name: 'Bistrita-Nasaud',
        shortCode: 'BN',
      },
      {
        name: 'Botosani',
        shortCode: 'BT',
      },
      {
        name: 'Braila',
        shortCode: 'BR',
      },
      {
        name: 'Brasov',
        shortCode: 'BV',
      },
      {
        name: 'Bucuresti',
        shortCode: 'B',
      },
      {
        name: 'Buzau',
        shortCode: 'BZ',
      },
      {
        name: 'Calarasi',
        shortCode: 'CL',
      },
      {
        name: 'Caras-Severin',
        shortCode: 'CS',
      },
      {
        name: 'Cluj',
        shortCode: 'CJ',
      },
      {
        name: 'Constanta',
        shortCode: 'CT',
      },
      {
        name: 'Covasna',
        shortCode: 'CV',
      },
      {
        name: 'Dambovita',
        shortCode: 'DB',
      },
      {
        name: 'Dolj',
        shortCode: 'DJ',
      },
      {
        name: 'Galati',
        shortCode: 'GL',
      },
      {
        name: 'Giurgiu',
        shortCode: 'GR',
      },
      {
        name: 'Gorj',
        shortCode: 'GJ',
      },
      {
        name: 'Harghita',
        shortCode: 'HR',
      },
      {
        name: 'Hunedoara',
        shortCode: 'HD',
      },
      {
        name: 'Ialomita',
        shortCode: 'IL',
      },
      {
        name: 'Iasi',
        shortCode: 'IS',
      },
      {
        name: 'Maramures',
        shortCode: 'MM',
      },
      {
        name: 'Mehedinti',
        shortCode: 'MH',
      },
      {
        name: 'Mures',
        shortCode: 'MS',
      },
      {
        name: 'Neamt',
        shortCode: 'NT',
      },
      {
        name: 'Olt',
        shortCode: 'OT',
      },
      {
        name: 'Prahova',
        shortCode: 'PH',
      },
      {
        name: 'Salaj',
        shortCode: 'SJ',
      },
      {
        name: 'Satu Mare',
        shortCode: 'SM',
      },
      {
        name: 'Sibiu',
        shortCode: 'SB',
      },
      {
        name: 'Suceava',
        shortCode: 'SV',
      },
      {
        name: 'Teleorman',
        shortCode: 'TR',
      },
      {
        name: 'Timis',
        shortCode: 'TM',
      },
      {
        name: 'Tulcea',
        shortCode: 'TL',
      },
      {
        name: 'Valcea',
        shortCode: 'VL',
      },
      {
        name: 'Vaslui',
        shortCode: 'VS',
      },
      {
        name: 'Vrancea',
        shortCode: 'VN',
      },
    ],
  },
  {
    countryCode: 'ru',
    languageCode: 'ru',
    locale: 'ru-ru',
    country: 'COUNTRY.RUSSIA',
    language: 'LANGUAGE.RUSSIAN',
    regions: [
      {
        name: 'Republic of Adygea',
        shortCode: 'AD',
      },
      {
        name: 'Republic of Altai (Gorno-Altaysk)',
        shortCode: 'AL',
      },
      {
        name: 'Altai Krai',
        shortCode: 'ALT',
      },
      {
        name: 'Amur Oblast',
        shortCode: 'AMU',
      },
      {
        name: 'Arkhangelsk Oblast',
        shortCode: 'ARK',
      },
      {
        name: 'Astrakhan Oblast',
        shortCode: 'AST',
      },
      {
        name: 'Republic of Bashkortostan',
        shortCode: 'BA',
      },
      {
        name: 'Belgorod Oblast',
        shortCode: 'BEL',
      },
      {
        name: 'Bryansk Oblast',
        shortCode: 'BRY',
      },
      {
        name: 'Republic of Buryatia',
        shortCode: 'BU',
      },
      {
        name: 'Chechen Republic',
        shortCode: 'CE',
      },
      {
        name: 'Chelyabinsk Oblast',
        shortCode: 'CHE',
      },
      {
        name: 'Chukotka Autonomous Okrug',
        shortCode: 'CHU',
      },
      {
        name: 'Chuvash Republic',
        shortCode: 'CU',
      },
      {
        name: 'Republic of Dagestan',
        shortCode: 'DA',
      },
      {
        name: 'Republic of Ingushetia',
        shortCode: 'IN',
      },
      {
        name: 'Irkutsk Oblast',
        shortCode: 'IRK',
      },
      {
        name: 'Ivanovo Oblast',
        shortCode: 'IVA',
      },
      {
        name: 'Jewish Autonomous Oblast',
        shortCode: 'JEW',
      },
      {
        name: 'Kabardino-Balkar Republic',
        shortCode: 'KB',
      },
      {
        name: 'Kaliningrad Oblast',
        shortCode: 'KLN',
      },
      {
        name: 'Republic of Kalmykia',
        shortCode: 'KL',
      },
      {
        name: 'Kaluga Oblast',
        shortCode: 'KLU',
      },
      {
        name: 'Kamchatka Krai',
        shortCode: 'KAM',
      },
      {
        name: 'Karachay-Cherkess Republic',
        shortCode: 'KC',
      },
      {
        name: 'Republic of Karelia',
        shortCode: 'KR',
      },
      {
        name: 'Khabarovsk Krai',
        shortCode: 'KHA',
      },
      {
        name: 'Republic of Khakassia',
        shortCode: 'KK',
      },
      {
        name: 'Khanty-Mansi Autonomous Okrug - Yugra',
        shortCode: 'KHM',
      },
      {
        name: 'Kemerovo Oblast',
        shortCode: 'KEM',
      },
      {
        name: 'Kirov Oblast',
        shortCode: 'KIR',
      },
      {
        name: 'Komi Republic',
        shortCode: 'KO',
      },
      {
        name: 'Kostroma Oblast',
        shortCode: 'KOS',
      },
      {
        name: 'Krasnodar Krai',
        shortCode: 'KDA',
      },
      {
        name: 'Krasnoyarsk Krai',
        shortCode: 'KYA',
      },
      {
        name: 'Kurgan Oblast',
        shortCode: 'KGN',
      },
      {
        name: 'Kursk Oblast',
        shortCode: 'KRS',
      },
      {
        name: 'Leningrad Oblast',
        shortCode: 'LEN',
      },
      {
        name: 'Lipetsk Oblast',
        shortCode: 'LIP',
      },
      {
        name: 'Magadan Oblast',
        shortCode: 'MAG',
      },
      {
        name: 'Mari El Republic',
        shortCode: 'ME',
      },
      {
        name: 'Republic of Mordovia',
        shortCode: 'MO',
      },
      {
        name: 'Moscow Oblast',
        shortCode: 'MOS',
      },
      {
        name: 'Moscow',
        shortCode: 'MOW',
      },
      {
        name: 'Murmansk Oblast',
        shortCode: 'MU',
      },
      {
        name: 'Nenets Autonomous Okrug',
        shortCode: 'NEN',
      },
      {
        name: 'Nizhny Novgorod Oblast',
        shortCode: 'NIZ',
      },
      {
        name: 'Novgorod Oblast',
        shortCode: 'NGR',
      },
      {
        name: 'Novosibirsk Oblast',
        shortCode: 'NVS',
      },
      {
        name: 'Omsk Oblast',
        shortCode: 'OMS',
      },
      {
        name: 'Orenburg Oblast',
        shortCode: 'ORE',
      },
      {
        name: 'Oryol Oblast',
        shortCode: 'ORL',
      },
      {
        name: 'Penza Oblast',
        shortCode: 'PNZ',
      },
      {
        name: 'Perm Krai',
        shortCode: 'PER',
      },
      {
        name: 'Primorsky Krai',
        shortCode: 'PRI',
      },
      {
        name: 'Pskov Oblast',
        shortCode: 'PSK',
      },
      {
        name: 'Rostov Oblast',
        shortCode: 'ROS',
      },
      {
        name: 'Ryazan Oblast',
        shortCode: 'RYA',
      },
      {
        name: 'Saint Petersburg',
        shortCode: 'SPE',
      },
      {
        name: 'Sakha (Yakutia) Republic',
        shortCode: 'SA',
      },
      {
        name: 'Sakhalin Oblast',
        shortCode: 'SAK',
      },
      {
        name: 'Samara Oblast',
        shortCode: 'SAM',
      },
      {
        name: 'Saratov Oblast',
        shortCode: 'SAR',
      },
      {
        name: 'Republic of North Ossetia-Alania',
        shortCode: 'NOA',
      },
      {
        name: 'Smolensk Oblast',
        shortCode: 'SMO',
      },
      {
        name: 'Stavropol Krai',
        shortCode: 'STA',
      },
      {
        name: 'Sverdlovsk Oblast',
        shortCode: 'SVE',
      },
      {
        name: 'Tambov Oblast',
        shortCode: 'TAM',
      },
      {
        name: 'Republic of Tatarstan',
        shortCode: 'TA',
      },
      {
        name: 'Tomsk Oblast',
        shortCode: 'TOM',
      },
      {
        name: 'Tuva Republic',
        shortCode: 'TU',
      },
      {
        name: 'Tula Oblast',
        shortCode: 'TUL',
      },
      {
        name: 'Tver Oblast',
        shortCode: 'TVE',
      },
      {
        name: 'Tyumen Oblast',
        shortCode: 'TYU',
      },
      {
        name: 'Udmurt Republic',
        shortCode: 'UD',
      },
      {
        name: 'Ulyanovsk Oblast',
        shortCode: 'ULY',
      },
      {
        name: 'Vladimir Oblast',
        shortCode: 'VLA',
      },
      {
        name: 'Volgograd Oblast',
        shortCode: 'VGG',
      },
      {
        name: 'Vologda Oblast',
        shortCode: 'VLG',
      },
      {
        name: 'Voronezh Oblast',
        shortCode: 'VOR',
      },
      {
        name: 'Yamalo-Nenets Autonomous Okrug',
        shortCode: 'YAN',
      },
      {
        name: 'Yaroslavl Oblast',
        shortCode: 'YAR',
      },
      {
        name: 'Zabaykalsky Krai',
        shortCode: 'ZAB',
      },
    ],
  },
  {
    countryCode: 'rs',
    languageCode: 'sr',
    locale: 'sr-rs',
    country: 'COUNTRY.SERBIA',
    language: 'LANGUAGE.SERBIAN',
    regions: [
      {
        name: 'Beograd (Belgrade)',
        shortCode: '00',
      },
      {
        name: 'Borski',
        shortCode: '14',
      },
      {
        name: 'Braničevski',
        shortCode: '11',
      },
      {
        name: 'Jablanički',
        shortCode: '23',
      },
      {
        name: 'Južnobački',
        shortCode: '06',
      },
      {
        name: 'Južnobanatski',
        shortCode: '04',
      },
      {
        name: 'Kolubarski',
        shortCode: '09',
      },
      {
        name: 'Kosovski',
        shortCode: '25',
      },
      {
        name: 'Kosovsko-Mitrovački',
        shortCode: '28',
      },
      {
        name: 'Kosovsko-Pomoravski',
        shortCode: '29',
      },
      {
        name: 'Mačvanski',
        shortCode: '08',
      },
      {
        name: 'Moravički',
        shortCode: '17',
      },
      {
        name: 'Nišavski',
        shortCode: '20',
      },
      {
        name: 'Pčinjski',
        shortCode: '24',
      },
      {
        name: 'Pećki',
        shortCode: '26',
      },
      {
        name: 'Pirotski',
        shortCode: '22',
      },
      {
        name: 'Podunavski',
        shortCode: '10',
      },
      {
        name: 'Pomoravski',
        shortCode: '13',
      },
      {
        name: 'Prizrenski',
        shortCode: '27',
      },
      {
        name: 'Rasinski',
        shortCode: '19',
      },
      {
        name: 'Raški',
        shortCode: '18',
      },
      {
        name: 'Severnobački',
        shortCode: '01',
      },
      {
        name: 'Severnobanatski',
        shortCode: '03',
      },
      {
        name: 'Srednjebanatski',
        shortCode: '02',
      },
      {
        name: 'Sremski',
        shortCode: '07',
      },
      {
        name: 'Šumadijski',
        shortCode: '12',
      },
      {
        name: 'Toplički',
        shortCode: '21',
      },
      {
        name: 'Zaječarski',
        shortCode: '15',
      },
      {
        name: 'Zapadnobački',
        shortCode: '05',
      },
      {
        name: 'Zlatiborski',
        shortCode: '16',
      },
    ],
  },
  {
    countryCode: 'sk',
    languageCode: 'sk',
    locale: 'sk-sk',
    country: 'COUNTRY.SLOVAKIA',
    language: 'LANGUAGE.SLOVAK',
    regions: [
      {
        name: 'Banskobystricky',
        shortCode: 'BC',
      },
      {
        name: 'Bratislavsky',
        shortCode: 'BL',
      },
      {
        name: 'Kosicky',
        shortCode: 'KI',
      },
      {
        name: 'Nitriansky',
        shortCode: 'NI',
      },
      {
        name: 'Presovsky',
        shortCode: 'PV',
      },
      {
        name: 'Trenciansky',
        shortCode: 'TC',
      },
      {
        name: 'Trnavsky',
        shortCode: 'TA',
      },
      {
        name: 'Zilinsky',
        shortCode: 'ZI',
      },
    ],
  },
  {
    countryCode: 'si',
    languageCode: 'sl',
    locale: 'sl-si',
    country: 'COUNTRY.SLOVENIA',
    language: 'LANGUAGE.SLOVENIAN',
    regions: [
      {
        name: 'Ajdovscina',
        shortCode: '001',
      },
      {
        name: 'Apace',
        shortCode: '195',
      },
      {
        name: 'Beltinci',
        shortCode: '002',
      },
      {
        name: 'Benedikt',
        shortCode: '148',
      },
      {
        name: 'Bistrica ob Sotli',
        shortCode: '149',
      },
      {
        name: 'Bled',
        shortCode: '003',
      },
      {
        name: 'Bloke',
        shortCode: '150',
      },
      {
        name: 'Bohinj',
        shortCode: '004',
      },
      {
        name: 'Borovnica',
        shortCode: '005',
      },
      {
        name: 'Bovec',
        shortCode: '006',
      },
      {
        name: 'Braslovce',
        shortCode: '151',
      },
      {
        name: 'Brda',
        shortCode: '007',
      },
      {
        name: 'Brezice',
        shortCode: '009',
      },
      {
        name: 'Brezovica',
        shortCode: '008',
      },
      {
        name: 'Cankova',
        shortCode: '152',
      },
      {
        name: 'Celje',
        shortCode: '011',
      },
      {
        name: 'Cerklje na Gorenjskem',
        shortCode: '012',
      },
      {
        name: 'Cerknica',
        shortCode: '013',
      },
      {
        name: 'Cerkno',
        shortCode: '014',
      },
      {
        name: 'Cerkvenjak',
        shortCode: '153',
      },
      {
        name: 'Cirkulane',
        shortCode: '196',
      },
      {
        name: 'Crensovci',
        shortCode: '015',
      },
      {
        name: 'Crna na Koroskem',
        shortCode: '016',
      },
      {
        name: 'Crnomelj',
        shortCode: '017',
      },
      {
        name: 'Destrnik',
        shortCode: '018',
      },
      {
        name: 'Divaca',
        shortCode: '019',
      },
      {
        name: 'Dobje',
        shortCode: '154',
      },
      {
        name: 'Dobrepolje',
        shortCode: '020',
      },
      {
        name: 'Dobrna',
        shortCode: '155',
      },
      {
        name: 'Dobrova-Polhov Gradec',
        shortCode: '021',
      },
      {
        name: 'Dobrovnik',
        shortCode: '156',
      },
      {
        name: 'Dol pri Ljubljani',
        shortCode: '022',
      },
      {
        name: 'Dolenjske Toplice',
        shortCode: '157',
      },
      {
        name: 'Domzale',
        shortCode: '023',
      },
      {
        name: 'Dornava',
        shortCode: '024',
      },
      {
        name: 'Dravograd',
        shortCode: '025',
      },
      {
        name: 'Duplek',
        shortCode: '026',
      },
      {
        name: 'Gorenja Vas-Poljane',
        shortCode: '027',
      },
      {
        name: 'Gorisnica',
        shortCode: '028',
      },
      {
        name: 'Gorje',
        shortCode: '207',
      },
      {
        name: 'Gornja Radgona',
        shortCode: '029',
      },
      {
        name: 'Gornji Grad',
        shortCode: '030',
      },
      {
        name: 'Gornji Petrovci',
        shortCode: '031',
      },
      {
        name: 'Grad',
        shortCode: '158',
      },
      {
        name: 'Grosuplje',
        shortCode: '032',
      },
      {
        name: 'Hajdina',
        shortCode: '159',
      },
      {
        name: 'Hoce-Slivnica',
        shortCode: '160',
      },
      {
        name: 'Hodos',
        shortCode: '161',
      },
      {
        name: 'Horjul',
        shortCode: '162',
      },
      {
        name: 'Hrastnik',
        shortCode: '034',
      },
      {
        name: 'Hrpelje-Kozina',
        shortCode: '035',
      },
      {
        name: 'Idrija',
        shortCode: '036',
      },
      {
        name: 'Ig',
        shortCode: '037',
      },
      {
        name: 'Ilirska Bistrica',
        shortCode: '038',
      },
      {
        name: 'Ivancna Gorica',
        shortCode: '039',
      },
      {
        name: 'Izola',
        shortCode: '040s',
      },
      {
        name: 'Jesenice',
        shortCode: '041',
      },
      {
        name: 'Jursinci',
        shortCode: '042',
      },
      {
        name: 'Kamnik',
        shortCode: '043',
      },
      {
        name: 'Kanal',
        shortCode: '044',
      },
      {
        name: 'Kidricevo',
        shortCode: '045',
      },
      {
        name: 'Kobarid',
        shortCode: '046',
      },
      {
        name: 'Kobilje',
        shortCode: '047',
      },
      {
        name: 'Kocevje',
        shortCode: '048',
      },
      {
        name: 'Komen',
        shortCode: '049',
      },
      {
        name: 'Komenda',
        shortCode: '164',
      },
      {
        name: 'Koper',
        shortCode: '050',
      },
      {
        name: 'Kodanjevica na Krki',
        shortCode: '197',
      },
      {
        name: 'Kostel',
        shortCode: '165',
      },
      {
        name: 'Kozje',
        shortCode: '051',
      },
      {
        name: 'Kranj',
        shortCode: '052',
      },
      {
        name: 'Kranjska Gora',
        shortCode: '053',
      },
      {
        name: 'Krizevci',
        shortCode: '166',
      },
      {
        name: 'Krsko',
        shortCode: '054',
      },
      {
        name: 'Kungota',
        shortCode: '055',
      },
      {
        name: 'Kuzma',
        shortCode: '056',
      },
      {
        name: 'Lasko',
        shortCode: '057',
      },
      {
        name: 'Lenart',
        shortCode: '058',
      },
      {
        name: 'Lendava',
        shortCode: '059',
      },
      {
        name: 'Litija',
        shortCode: '068',
      },
      {
        name: 'Ljubljana',
        shortCode: '061',
      },
      {
        name: 'Ljubno',
        shortCode: '062',
      },
      {
        name: 'Ljutomer',
        shortCode: '063',
      },
      {
        name: 'Log-Dragomer',
        shortCode: '208',
      },
      {
        name: 'Logatec',
        shortCode: '064',
      },
      {
        name: 'Loska Dolina',
        shortCode: '065',
      },
      {
        name: 'Loski Potok',
        shortCode: '066',
      },
      {
        name: 'Lovrenc na Pohorju',
        shortCode: '167',
      },
      {
        name: 'Lukovica',
        shortCode: '068',
      },
      {
        name: 'Luce',
        shortCode: '067',
      },
      {
        name: 'Majsperk',
        shortCode: '069',
      },
      {
        name: 'Makole',
        shortCode: '198',
      },
      {
        name: 'Maribor',
        shortCode: '070',
      },
      {
        name: 'Markovci',
        shortCode: '168',
      },
      {
        name: 'Medvode',
        shortCode: '071',
      },
      {
        name: 'Menges',
        shortCode: '072',
      },
      {
        name: 'Metlika',
        shortCode: '073',
      },
      {
        name: 'Mezica',
        shortCode: '074',
      },
      {
        name: 'Miklavz na Dravskem Polju',
        shortCode: '169',
      },
      {
        name: 'Miren-Kostanjevica',
        shortCode: '075',
      },
      {
        name: 'Mirna',
        shortCode: '212',
      },
      {
        name: 'Mirna Pec',
        shortCode: '170',
      },
      {
        name: 'Mislinja',
        shortCode: '076',
      },
      {
        name: 'Mokronog-Trebelno',
        shortCode: '199',
      },
      {
        name: 'Moravce',
        shortCode: '077',
      },
      {
        name: 'Moravske Toplice',
        shortCode: '078',
      },
      {
        name: 'Mozirje',
        shortCode: '079',
      },
      {
        name: 'Murska Sobota',
        shortCode: '080',
      },
      {
        name: 'Naklo',
        shortCode: '082',
      },
      {
        name: 'Nazarje',
        shortCode: '083',
      },
      {
        name: 'Nova Gorica',
        shortCode: '084',
      },
      {
        name: 'Novo Mesto',
        shortCode: '085',
      },
      {
        name: 'Odranci',
        shortCode: '086',
      },
      {
        name: 'Ormoz',
        shortCode: '087',
      },
      {
        name: 'Osilnica',
        shortCode: '088',
      },
      {
        name: 'Pesnica',
        shortCode: '089',
      },
      {
        name: 'Piran',
        shortCode: '090',
      },
      {
        name: 'Pivka',
        shortCode: '091',
      },
      {
        name: 'Podcetrtek',
        shortCode: '092',
      },
      {
        name: 'Podlehnik',
        shortCode: '172',
      },
      {
        name: 'Podvelka',
        shortCode: '093',
      },
      {
        name: 'Poljcane',
        shortCode: '200',
      },
      {
        name: 'Postojna',
        shortCode: '094',
      },
      {
        name: 'Prebold',
        shortCode: '174',
      },
      {
        name: 'Preddvor',
        shortCode: '095',
      },
      {
        name: 'Prevalje',
        shortCode: '175',
      },
      {
        name: 'Ptuj',
        shortCode: '096',
      },
      {
        name: 'Race-Fram',
        shortCode: '098',
      },
      {
        name: 'Radece',
        shortCode: '099',
      },
      {
        name: 'Radenci',
        shortCode: '100',
      },
      {
        name: 'Radlje ob Dravi',
        shortCode: '101',
      },
      {
        name: 'Radovljica',
        shortCode: '102',
      },
      {
        name: 'Ravne na Koroskem',
        shortCode: '103',
      },
      {
        name: 'Razkrizje',
        shortCode: '176',
      },
      {
        name: 'Recica ob Savinji',
        shortCode: '209',
      },
      {
        name: 'Rence-Vogrsko',
        shortCode: '201',
      },
      {
        name: 'Ribnica',
        shortCode: '104',
      },
      {
        name: 'Ribnica na Poboriu',
        shortCode: '177',
      },
      {
        name: 'Rogaska Slatina',
        shortCode: '106',
      },
      {
        name: 'Rogasovci',
        shortCode: '105',
      },
      {
        name: 'Rogatec',
        shortCode: '107',
      },
      {
        name: 'Ruse',
        shortCode: '108',
      },
      {
        name: 'Salovci',
        shortCode: '033',
      },
      {
        name: 'Selnica ob Dravi',
        shortCode: '178',
      },
      {
        name: 'Semic',
        shortCode: '109',
      },
      {
        name: 'Sempeter-Vrtojba',
        shortCode: '183',
      },
      {
        name: 'Sencur',
        shortCode: '117',
      },
      {
        name: 'Sentilj',
        shortCode: '118',
      },
      {
        name: 'Sentjernej',
        shortCode: '119',
      },
      {
        name: 'Sentjur',
        shortCode: '120',
      },
      {
        name: 'Sentrupert',
        shortCode: '211',
      },
      {
        name: 'Sevnica',
        shortCode: '110',
      },
      {
        name: 'Sezana',
        shortCode: '111',
      },
      {
        name: 'Skocjan',
        shortCode: '121',
      },
      {
        name: 'Skofja Loka',
        shortCode: '122',
      },
      {
        name: 'Skofljica',
        shortCode: '123',
      },
      {
        name: 'Slovenj Gradec',
        shortCode: '112',
      },
      {
        name: 'Slovenska Bistrica',
        shortCode: '113',
      },
      {
        name: 'Slovenske Konjice',
        shortCode: '114',
      },
      {
        name: 'Smarje pri elsah',
        shortCode: '124',
      },
      {
        name: 'Smarjeske Toplice',
        shortCode: '206',
      },
      {
        name: 'Smartno ob Paki',
        shortCode: '125',
      },
      {
        name: 'Smartno pri Litiji',
        shortCode: '194',
      },
      {
        name: 'Sodrazica',
        shortCode: '179',
      },
      {
        name: 'Solcava',
        shortCode: '180',
      },
      {
        name: 'Sostanj',
        shortCode: '126',
      },
      {
        name: 'Sredisce ob Dravi',
        shortCode: '202',
      },
      {
        name: 'Starse',
        shortCode: '115',
      },
      {
        name: 'Store',
        shortCode: '127',
      },
      {
        name: 'Straza',
        shortCode: '203',
      },
      {
        name: 'Sveta Ana',
        shortCode: '181',
      },
      {
        name: 'Sveta Trojica v Slovenskih Goricah',
        shortCode: '204',
      },
      {
        name: 'Sveta Andraz v Slovenskih Goricah',
        shortCode: '182',
      },
      {
        name: 'Sveti Jurij',
        shortCode: '116',
      },
      {
        name: 'Sveti Jurij v Slovenskih Goricah',
        shortCode: '210',
      },
      {
        name: 'Sveti Tomaz',
        shortCode: '205',
      },
      {
        name: 'Tabor',
        shortCode: '184',
      },
      {
        name: 'Tisina',
        shortCode: '128',
      },
      {
        name: 'Tolmin',
        shortCode: '128',
      },
      {
        name: 'Trbovlje',
        shortCode: '129',
      },
      {
        name: 'Trebnje',
        shortCode: '130',
      },
      {
        name: 'Trnovska Vas',
        shortCode: '185',
      },
      {
        name: 'Trzin',
        shortCode: '186',
      },
      {
        name: 'Trzic',
        shortCode: '131',
      },
      {
        name: 'Turnisce',
        shortCode: '132',
      },
      {
        name: 'Velenje',
        shortCode: '133',
      },
      {
        name: 'Velika Polana',
        shortCode: '187',
      },
      {
        name: 'Velike Lasce',
        shortCode: '134',
      },
      {
        name: 'Verzej',
        shortCode: '188',
      },
      {
        name: 'Videm',
        shortCode: '135',
      },
      {
        name: 'Vipava',
        shortCode: '136',
      },
      {
        name: 'Vitanje',
        shortCode: '137',
      },
      {
        name: 'Vodice',
        shortCode: '138',
      },
      {
        name: 'Vojnik',
        shortCode: '139',
      },
      {
        name: 'Vransko',
        shortCode: '189',
      },
      {
        name: 'Vrhnika',
        shortCode: '140',
      },
      {
        name: 'Vuzenica',
        shortCode: '141',
      },
      {
        name: 'Zagorje ob Savi',
        shortCode: '142',
      },
      {
        name: 'Zavrc',
        shortCode: '143',
      },
      {
        name: 'Zrece',
        shortCode: '144',
      },
      {
        name: 'Zalec',
        shortCode: '190',
      },
      {
        name: 'Zelezniki',
        shortCode: '146',
      },
      {
        name: 'Zetale',
        shortCode: '191',
      },
      {
        name: 'Ziri',
        shortCode: '147',
      },
      {
        name: 'Zirovnica',
        shortCode: '192',
      },
      {
        name: 'Zuzemberk',
        shortCode: '193',
      },
    ],
  },
  {
    countryCode: 'es',
    languageCode: 'es',
    country: 'COUNTRY.SPAIN',
    language: 'LANGUAGE.SPANISH',
    regions: [
      {
        name: 'Albacete',
        shortCode: 'CM',
      },
      {
        name: 'Alicante',
        shortCode: 'VC',
      },
      {
        name: 'Almería',
        shortCode: 'AN',
      },
      {
        name: 'Araba/Álava',
        shortCode: 'VI',
      },
      {
        name: 'Asturias',
        shortCode: 'O',
      },
      {
        name: 'Ávila',
        shortCode: 'AV',
      },
      {
        name: 'Badajoz',
        shortCode: 'BA',
      },
      {
        name: 'Barcelona',
        shortCode: 'B',
      },
      {
        name: 'Bizkaia',
        shortCode: 'BI',
      },
      {
        name: 'Burgos',
        shortCode: 'BU',
      },
      {
        name: 'Cáceres',
        shortCode: 'CC',
      },
      {
        name: 'Cádiz',
        shortCode: 'CA',
      },
      {
        name: 'Cantabria',
        shortCode: 'S',
      },
      {
        name: 'Castellón',
        shortCode: 'CS',
      },
      {
        name: 'Cueta',
        shortCode: 'CU',
      },
      {
        name: 'Ciudad Real',
        shortCode: 'CR',
      },
      {
        name: 'Córdoba',
        shortCode: 'CO',
      },
      {
        name: 'A Coruña',
        shortCode: 'C',
      },
      {
        name: 'Cuenca',
        shortCode: 'CU',
      },
      {
        name: 'Gipuzkoa',
        shortCode: 'SS',
      },
      {
        name: 'Girona',
        shortCode: 'GI',
      },
      {
        name: 'Granada',
        shortCode: 'GR',
      },
      {
        name: 'Guadalajara',
        shortCode: 'GU',
      },
      {
        name: 'Huelva',
        shortCode: 'H',
      },
      {
        name: 'Huesca',
        shortCode: 'HU',
      },
      {
        name: 'Illes Balears',
        shortCode: 'PM',
      },
      {
        name: 'Jaén',
        shortCode: 'J',
      },
      {
        name: 'León',
        shortCode: 'LE',
      },
      {
        name: 'Lleida',
        shortCode: 'L',
      },
      {
        name: 'Lugo',
        shortCode: 'LU',
      },
      {
        name: 'Madrid',
        shortCode: 'M',
      },
      {
        name: 'Málaga',
        shortCode: 'MA',
      },
      {
        name: 'Melilla',
        shortCode: 'ML',
      },
      {
        name: 'Murcia',
        shortCode: 'MU',
      },
      {
        name: 'Navarre',
        shortCode: 'NA',
      },
      {
        name: 'Ourense',
        shortCode: 'OR',
      },
      {
        name: 'Palencia',
        shortCode: 'P',
      },
      {
        name: 'Las Palmas',
        shortCode: 'GC',
      },
      {
        name: 'Pontevedra',
        shortCode: 'PO',
      },
      {
        name: 'La Rioja',
        shortCode: 'LO',
      },
      {
        name: 'Salamanca',
        shortCode: 'SA',
      },
      {
        name: 'Santa Cruz de Tenerife',
        shortCode: 'TF',
      },
      {
        name: 'Segovia',
        shortCode: 'SG',
      },
      {
        name: 'Sevilla',
        shortCode: 'SE',
      },
      {
        name: 'Soria',
        shortCode: 'SO',
      },
      {
        name: 'Tarragona',
        shortCode: 'T',
      },
      {
        name: 'Teruel',
        shortCode: 'TE',
      },
      {
        name: 'Toledo',
        shortCode: 'TO',
      },
      {
        name: 'Valencia',
        shortCode: 'V',
      },
      {
        name: 'Valladolid',
        shortCode: 'VA',
      },
      {
        name: 'Zamora',
        shortCode: 'ZA',
      },
      {
        name: 'Zaragoza',
        shortCode: 'Z',
      },
    ],
  },
  {
    countryCode: 'se',
    languageCode: 'sv',
    locale: 'sv-se',
    country: 'COUNTRY.SWEDEN',
    language: 'LANGUAGE.SWEDISH',
    regions: [
      {
        name: 'Blekinge',
        shortCode: 'K',
      },
      {
        name: 'Dalarnas',
        shortCode: 'W',
      },
      {
        name: 'Gotlands',
        shortCode: 'X',
      },
      {
        name: 'Gavleborgs',
        shortCode: 'I',
      },
      {
        name: 'Hallands',
        shortCode: 'N',
      },
      {
        name: 'Jamtlands',
        shortCode: 'Z',
      },
      {
        name: 'Jonkopings',
        shortCode: 'F',
      },
      {
        name: 'Kalmar',
        shortCode: 'H',
      },
      {
        name: 'Kronobergs',
        shortCode: 'G',
      },
      {
        name: 'Norrbottens',
        shortCode: 'BD',
      },
      {
        name: 'Orebro',
        shortCode: 'T',
      },
      {
        name: 'Ostergotlands',
        shortCode: 'E',
      },
      {
        name: 'Skane',
        shortCode: 'M',
      },
      {
        name: 'Sodermanlands',
        shortCode: 'D',
      },
      {
        name: 'Stockholm',
        shortCode: 'AB',
      },
      {
        name: 'Varmlands',
        shortCode: 'S',
      },
      {
        name: 'Vasterbottens',
        shortCode: 'AC',
      },
      {
        name: 'Vasternorrlands',
        shortCode: 'Y',
      },
      {
        name: 'Vastmanlands',
        shortCode: 'U',
      },
      {
        name: 'Vastra Gotalands',
        shortCode: 'O',
      },
    ],
  },
  {
    countryCode: 'ch',
    languageCode: 'de',
    locale: 'de-ch',
    country: 'COUNTRY.SWITZERLAND',
    language: 'LANGUAGE.GERMAN',
    regions: [
      {
        name: 'Aargau',
        shortCode: 'AG',
      },
      {
        name: 'Appenzell Ausserrhoden',
        shortCode: 'AR',
      },
      {
        name: 'Appenzell Innerhoden',
        shortCode: 'AI',
      },
      {
        name: 'Basel-Landschaft',
        shortCode: 'BL',
      },
      {
        name: 'Basel-Stadt',
        shortCode: 'BS',
      },
      {
        name: 'Bern',
        shortCode: 'BE',
      },
      {
        name: 'Fribourg',
        shortCode: 'FR',
      },
      {
        name: 'Genève',
        shortCode: 'GE',
      },
      {
        name: 'Glarus',
        shortCode: 'GL',
      },
      {
        name: 'Graubünden',
        shortCode: 'GR',
      },
      {
        name: 'Jura',
        shortCode: 'JU',
      },
      {
        name: 'Luzern',
        shortCode: 'LU',
      },
      {
        name: 'Neuchâtel',
        shortCode: 'NE',
      },
      {
        name: 'Nidwalden',
        shortCode: 'NW',
      },
      {
        name: 'Obwalden',
        shortCode: 'OW',
      },
      {
        name: 'Sankt Gallen',
        shortCode: 'SG',
      },
      {
        name: 'Schaffhausen',
        shortCode: 'SH',
      },
      {
        name: 'Schwyz',
        shortCode: 'SZ',
      },
      {
        name: 'Solothurn',
        shortCode: 'SO',
      },
      {
        name: 'Thurgau',
        shortCode: 'TG',
      },
      {
        name: 'Ticino',
        shortCode: 'TI',
      },
      {
        name: 'Uri',
        shortCode: 'UR',
      },
      {
        name: 'Valais',
        shortCode: 'VS',
      },
      {
        name: 'Vaud',
        shortCode: 'VD',
      },
      {
        name: 'Zug',
        shortCode: 'ZG',
      },
      {
        name: 'Zürich',
        shortCode: 'ZH',
      },
    ],
  },
  {
    countryCode: 'ch_fr',
    languageCode: 'fr',
    locale: 'fr-ch',
    country: 'COUNTRY.SWITZERLAND',
    language: 'LANGUAGE.FRENCH',
    regions: [],
  },
  {
    countryCode: 'tr',
    languageCode: 'tr',
    locale: 'tr-tr',
    country: 'COUNTRY.TURKEY',
    language: 'LANGUAGE.TURKISH',
    regions: [
      {
        name: 'Adana',
        shortCode: '01',
      },
      {
        name: 'Adiyaman',
        shortCode: '02',
      },
      {
        name: 'Afyonkarahisar',
        shortCode: '03',
      },
      {
        name: 'Agri',
        shortCode: '04',
      },
      {
        name: 'Aksaray',
        shortCode: '68',
      },
      {
        name: 'Amasya',
        shortCode: '05',
      },
      {
        name: 'Ankara',
        shortCode: '06',
      },
      {
        name: 'Antalya',
        shortCode: '07',
      },
      {
        name: 'Ardahan',
        shortCode: '75',
      },
      {
        name: 'Artvin',
        shortCode: '08',
      },
      {
        name: 'Aydin',
        shortCode: '09',
      },
      {
        name: 'Balikesir',
        shortCode: '10',
      },
      {
        name: 'Bartin',
        shortCode: '74',
      },
      {
        name: 'Batman',
        shortCode: '72',
      },
      {
        name: 'Bayburt',
        shortCode: '69',
      },
      {
        name: 'Bilecik',
        shortCode: '11',
      },
      {
        name: 'Bingol',
        shortCode: '12',
      },
      {
        name: 'Bitlis',
        shortCode: '13',
      },
      {
        name: 'Bolu',
        shortCode: '14',
      },
      {
        name: 'Burdur',
        shortCode: '15',
      },
      {
        name: 'Bursa',
        shortCode: '16',
      },
      {
        name: 'Canakkale',
        shortCode: '17',
      },
      {
        name: 'Cankiri',
        shortCode: '18',
      },
      {
        name: 'Corum',
        shortCode: '19',
      },
      {
        name: 'Denizli',
        shortCode: '20',
      },
      {
        name: 'Diyarbakir',
        shortCode: '21',
      },
      {
        name: 'Duzce',
        shortCode: '81',
      },
      {
        name: 'Edirne',
        shortCode: '22',
      },
      {
        name: 'Elazig',
        shortCode: '23',
      },
      {
        name: 'Erzincan',
        shortCode: '24',
      },
      {
        name: 'Erzurum',
        shortCode: '25',
      },
      {
        name: 'Eskisehir',
        shortCode: '26',
      },
      {
        name: 'Gaziantep',
        shortCode: '27',
      },
      {
        name: 'Giresun',
        shortCode: '28',
      },
      {
        name: 'Gumushane',
        shortCode: '29',
      },
      {
        name: 'Hakkari',
        shortCode: '30',
      },
      {
        name: 'Hatay',
        shortCode: '31',
      },
      {
        name: 'Igdir',
        shortCode: '76',
      },
      {
        name: 'Isparta',
        shortCode: '32',
      },
      {
        name: 'Istanbul',
        shortCode: '34',
      },
      {
        name: 'Izmir',
        shortCode: '35',
      },
      {
        name: 'Kahramanmaras',
        shortCode: '46',
      },
      {
        name: 'Karabuk',
        shortCode: '78',
      },
      {
        name: 'Karaman',
        shortCode: '70',
      },
      {
        name: 'Kars',
        shortCode: '36',
      },
      {
        name: 'Kastamonu',
        shortCode: '37',
      },
      {
        name: 'Kayseri',
        shortCode: '38',
      },
      {
        name: 'Kilis',
        shortCode: '79',
      },
      {
        name: 'Kirikkale',
        shortCode: '71',
      },
      {
        name: 'Kirklareli',
        shortCode: '39',
      },
      {
        name: 'Kirsehir',
        shortCode: '40',
      },
      {
        name: 'Kocaeli',
        shortCode: '41',
      },
      {
        name: 'Konya',
        shortCode: '42',
      },
      {
        name: 'Kutahya',
        shortCode: '43',
      },
      {
        name: 'Malatya',
        shortCode: '44',
      },
      {
        name: 'Manisa',
        shortCode: '45',
      },
      {
        name: 'Mardin',
        shortCode: '47',
      },
      {
        name: 'Mersin',
        shortCode: '33',
      },
      {
        name: 'Mugla',
        shortCode: '48',
      },
      {
        name: 'Mus',
        shortCode: '49',
      },
      {
        name: 'Nevsehir',
        shortCode: '50',
      },
      {
        name: 'Nigde',
        shortCode: '51',
      },
      {
        name: 'Ordu',
        shortCode: '52',
      },
      {
        name: 'Osmaniye',
        shortCode: '80',
      },
      {
        name: 'Rize',
        shortCode: '53',
      },
      {
        name: 'Sakarya',
        shortCode: '54',
      },
      {
        name: 'Samsun',
        shortCode: '55',
      },
      {
        name: 'Sanliurfa',
        shortCode: '63',
      },
      {
        name: 'Siirt',
        shortCode: '56',
      },
      {
        name: 'Sinop',
        shortCode: '57',
      },
      {
        name: 'Sirnak',
        shortCode: '73',
      },
      {
        name: 'Sivas',
        shortCode: '58',
      },
      {
        name: 'Tekirdag',
        shortCode: '59',
      },
      {
        name: 'Tokat',
        shortCode: '60',
      },
      {
        name: 'Trabzon',
        shortCode: '61',
      },
      {
        name: 'Tunceli',
        shortCode: '62',
      },
      {
        name: 'Usak',
        shortCode: '64',
      },
      {
        name: 'Van',
        shortCode: '65',
      },
      {
        name: 'Yalova',
        shortCode: '77',
      },
      {
        name: 'Yozgat',
        shortCode: '66',
      },
      {
        name: 'Zonguldak',
        shortCode: '67',
      },
    ],
  },
  {
    countryCode: 'lt',
    languageCode: 'lt',
    locale: 'lt-lt',
    country: 'COUNTRY.LITHUANIA',
    language: 'LANGUAGE.LITHUANIAN',
    regions: [
      {
        name: 'Alytaus',
        shortCode: 'AL',
      },
      {
        name: 'Kauno',
        shortCode: 'KU',
      },
      {
        name: 'Klaipėdos',
        shortCode: 'KL',
      },
      {
        name: 'Marijampolės',
        shortCode: 'MR',
      },
      {
        name: 'Panevėžio',
        shortCode: 'PN',
      },
      {
        name: 'Šiaulių',
        shortCode: 'SA',
      },
      {
        name: 'Tauragės',
        shortCode: 'TA',
      },
      {
        name: 'Telšių',
        shortCode: 'TE',
      },
      {
        name: 'Utenos',
        shortCode: 'UT',
      },
      {
        name: 'Vilniaus',
        shortCode: 'VL',
      },
    ],
  },
  {
    countryCode: 'ua',
    languageCode: 'uk',
    locale: 'uk-ua',
    country: 'COUNTRY.UKRAINE',
    language: 'LANGUAGE.UKRAINIAN',
    regions: [
      {
        name: 'Cherkasy',
        shortCode: '71',
      },
      {
        name: 'Chernihiv',
        shortCode: '74',
      },
      {
        name: 'Chernivtsi',
        shortCode: '77',
      },
      {
        name: 'Dnipropetrovsk',
        shortCode: '12',
      },
      {
        name: 'Donetsk',
        shortCode: '14',
      },
      {
        name: 'Ivano-Frankivsk',
        shortCode: '26',
      },
      {
        name: 'Kharkiv',
        shortCode: '63',
      },
      {
        name: 'Kherson',
        shortCode: '65',
      },
      {
        name: 'Khmelnytskyi',
        shortCode: '68',
      },
      {
        name: 'Kiev',
        shortCode: '32',
      },
      {
        name: 'Kirovohrad',
        shortCode: '35',
      },
      {
        name: 'Luhansk',
        shortCode: '09',
      },
      {
        name: 'Lviv',
        shortCode: '46',
      },
      {
        name: 'Mykolaiv',
        shortCode: '48',
      },
      {
        name: 'Odessa',
        shortCode: '51',
      },
      {
        name: 'Poltava',
        shortCode: '53',
      },
      {
        name: 'Rivne',
        shortCode: '56',
      },
      {
        name: 'Sumy',
        shortCode: '59',
      },
      {
        name: 'Ternopil',
        shortCode: '61',
      },
      {
        name: 'Vinnytsia',
        shortCode: '05',
      },
      {
        name: 'Volyn',
        shortCode: '07',
      },
      {
        name: 'Zakarpattia',
        shortCode: '21',
      },
      {
        name: 'Zaporizhia',
        shortCode: '23',
      },
      {
        name: 'Zhytomyr',
        shortCode: '18',
      },
      {
        name: 'Avtonomna Respublika Krym',
        shortCode: '43',
      },
      {
        name: 'Kyïv',
        shortCode: '30',
      },
      {
        name: 'Sevastopol',
        shortCode: '40',
      },
    ],
  },
  {
    countryCode: 'us',
    languageCode: 'en',
    locale: 'en-us',
    country: 'COUNTRY.UNITED_STATES',
    language: 'LANGUAGE.UNITED_STATES',
    regions: [
      {
        name: 'Alabama',
        shortCode: 'AL',
      },
      {
        name: 'Alaska',
        shortCode: 'AK',
      },
      {
        name: 'American Samoa',
        shortCode: 'AS',
      },
      {
        name: 'Arizona',
        shortCode: 'AZ',
      },
      {
        name: 'Arkansas',
        shortCode: 'AR',
      },
      {
        name: 'California',
        shortCode: 'CA',
      },
      {
        name: 'Colorado',
        shortCode: 'CO',
      },
      {
        name: 'Connecticut',
        shortCode: 'CT',
      },
      {
        name: 'Delaware',
        shortCode: 'DE',
      },
      {
        name: 'District of Columbia',
        shortCode: 'DC',
      },
      {
        name: 'Micronesia',
        shortCode: 'FM',
      },
      {
        name: 'Florida',
        shortCode: 'FL',
      },
      {
        name: 'Georgia',
        shortCode: 'GA',
      },
      {
        name: 'Guam',
        shortCode: 'GU',
      },
      {
        name: 'Hawaii',
        shortCode: 'HI',
      },
      {
        name: 'Idaho',
        shortCode: 'ID',
      },
      {
        name: 'Illinois',
        shortCode: 'IL',
      },
      {
        name: 'Indiana',
        shortCode: 'IN',
      },
      {
        name: 'Iowa',
        shortCode: 'IA',
      },
      {
        name: 'Kansas',
        shortCode: 'KS',
      },
      {
        name: 'Kentucky',
        shortCode: 'KY',
      },
      {
        name: 'Louisiana',
        shortCode: 'LA',
      },
      {
        name: 'Maine',
        shortCode: 'ME',
      },
      {
        name: 'Marshall Islands',
        shortCode: 'MH',
      },
      {
        name: 'Maryland',
        shortCode: 'MD',
      },
      {
        name: 'Massachusetts',
        shortCode: 'MA',
      },
      {
        name: 'Michigan',
        shortCode: 'MI',
      },
      {
        name: 'Minnesota',
        shortCode: 'MN',
      },
      {
        name: 'Mississippi',
        shortCode: 'MS',
      },
      {
        name: 'Missouri',
        shortCode: 'MO',
      },
      {
        name: 'Montana',
        shortCode: 'MT',
      },
      {
        name: 'Nebraska',
        shortCode: 'NE',
      },
      {
        name: 'Nevada',
        shortCode: 'NV',
      },
      {
        name: 'New Hampshire',
        shortCode: 'NH',
      },
      {
        name: 'New Jersey',
        shortCode: 'NJ',
      },
      {
        name: 'New Mexico',
        shortCode: 'NM',
      },
      {
        name: 'New York',
        shortCode: 'NY',
      },
      {
        name: 'North Carolina',
        shortCode: 'NC',
      },
      {
        name: 'North Dakota',
        shortCode: 'ND',
      },
      {
        name: 'Northern Mariana Islands',
        shortCode: 'MP',
      },
      {
        name: 'Ohio',
        shortCode: 'OH',
      },
      {
        name: 'Oklahoma',
        shortCode: 'OK',
      },
      {
        name: 'Oregon',
        shortCode: 'OR',
      },
      {
        name: 'Palau',
        shortCode: 'PW',
      },
      {
        name: 'Pennsylvania',
        shortCode: 'PA',
      },
      {
        name: 'Puerto Rico',
        shortCode: 'PR',
      },
      {
        name: 'Rhode Island',
        shortCode: 'RI',
      },
      {
        name: 'South Carolina',
        shortCode: 'SC',
      },
      {
        name: 'South Dakota',
        shortCode: 'SD',
      },
      {
        name: 'Tennessee',
        shortCode: 'TN',
      },
      {
        name: 'Texas',
        shortCode: 'TX',
      },
      {
        name: 'Utah',
        shortCode: 'UT',
      },
      {
        name: 'Vermont',
        shortCode: 'VT',
      },
      {
        name: 'Virgin Islands',
        shortCode: 'VI',
      },
      {
        name: 'Virginia',
        shortCode: 'VA',
      },
      {
        name: 'Washington',
        shortCode: 'WA',
      },
      {
        name: 'West Virginia',
        shortCode: 'WV',
      },
      {
        name: 'Wisconsin',
        shortCode: 'WI',
      },
      {
        name: 'Wyoming',
        shortCode: 'WY',
      },
      {
        name: 'Armed Forces Americas',
        shortCode: 'AA',
      },
      {
        name: 'Armed Forces Europe, Canada, Africa and Middle East',
        shortCode: 'AE',
      },
      {
        name: 'Armed Forces Pacific',
        shortCode: 'AP',
      },
    ],
  },
  {
    countryCode: 'ca',
    languageCode: 'en',
    locale: 'en-ca',
    country: 'COUNTRY.CANADA',
    language: 'LANGUAGE.CANADA',
    regions: [
      {
        name: 'Alberta',
        shortCode: 'AB',
      },
      {
        name: 'British Columbia',
        shortCode: 'BC',
      },
      {
        name: 'Manitoba',
        shortCode: 'MB',
      },
      {
        name: 'New Brunswick',
        shortCode: 'NB',
      },
      {
        name: 'Newfoundland and Labrador',
        shortCode: 'NL',
      },
      {
        name: 'Northwest Territories',
        shortCode: 'NT',
      },
      {
        name: 'Nova Scotia',
        shortCode: 'NS',
      },
      {
        name: 'Nunavut',
        shortCode: 'NU',
      },
      {
        name: 'Ontario',
        shortCode: 'ON',
      },
      {
        name: 'Prince Edward Island',
        shortCode: 'PE',
      },
      {
        name: 'Quebec',
        shortCode: 'QC',
      },
      {
        name: 'Saskatchewan',
        shortCode: 'SK',
      },
      {
        name: 'Yukon',
        shortCode: 'YT',
      },
    ],
  },
  {
    countryCode: 'no',
    languageCode: 'nn',
    locale: 'nn-no',
    country: 'COUNTRY.NORWAY',
    language: 'LANGUAGE.NORWEGIAN',
    regions: [
      {
        name: 'Akershus',
        shortCode: '02',
      },
      {
        name: 'Aust-Agder',
        shortCode: '09',
      },
      {
        name: 'Buskerud',
        shortCode: '06',
      },
      {
        name: 'Finnmark',
        shortCode: '20',
      },
      {
        name: 'Hedmark',
        shortCode: '04',
      },
      {
        name: 'Hordaland',
        shortCode: '12',
      },
      {
        name: 'Møre og Romsdal',
        shortCode: '15',
      },
      {
        name: 'Nordland',
        shortCode: '18',
      },
      {
        name: 'Nord-Trøndelag',
        shortCode: '17',
      },
      {
        name: 'Oppland',
        shortCode: '05',
      },
      {
        name: 'Oslo',
        shortCode: '03',
      },
      {
        name: 'Rogaland',
        shortCode: '11',
      },
      {
        name: 'Sogn og Fjordane',
        shortCode: '14',
      },
      {
        name: 'Sør-Trøndelag',
        shortCode: '16',
      },
      {
        name: 'Telemark',
        shortCode: '08',
      },
      {
        name: 'Troms',
        shortCode: '19',
      },
      {
        name: 'Vest-Agder',
        shortCode: '10',
      },
      {
        name: 'Vestfold',
        shortCode: '07',
      },
      {
        name: 'Østfold',
        shortCode: '01',
      },
      {
        name: 'Jan Mayen',
        shortCode: '22',
      },
      {
        name: 'Svalbard',
        shortCode: '21',
      },
    ],
  },
];

export const HIDDEN_LANGUAGES = ['CA', 'US'];
